import React, { Component } from 'react'; //different
import {
    BrowserRouter,
    Routes,
    Route
} from "react-router-dom";
import './App.css';
import Footer from './footer';
import jwt_decode from "jwt-decode";
import Swal from 'sweetalert2'
import instance from "./axios-instance";
import { NumericFormat } from 'react-number-format';
import Systems from "./SystemFunction";
import Casino from "./casino";
import Slot from "./slot";
import Fishing from "./fising";
import Sport from "./sport";
import TextSlider from "./textslide";
import Afficiate from "./affiliate";
import Signin from "./signin";
import Register from "./register";
import Loss from "./loss";
import Promotion from "./promotionx";
import { isMobile } from 'react-device-detect';
import Profile from "./profile";
import Statement from "./statement";



import Banner from "./banner";
import MoblieMenu from "./mobilemenu";
import Mainindex from "./mainindex";
import Lowmenu from "./lowmenu";
// import Lotto from "./lotto";
import Listgameall from "./linklistall";
// import GameHit from "./gamehit";
import moment from 'moment';
import md5 from 'md5';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { LoopTwoTone } from '@mui/icons-material';
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
var settings = {
    dots: true,
    infinite: true,
    slidesToShow: (window.innerWidth <= 760) ? 1 : 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 3000,
    cssEase: "linear"
};
class Main extends Component {
    constructor(props) {
        super(props)
        this.state = {
            categorylist: [],
            listitallgame: [],
            slotlist: [],
            sportlist: [],
            fishinglist: [],
            limit: [],
            tabselectdeposit: 0,
            rewardlist: [],
            slotlist: [],
            recentlist: [],
            activePage: 1,
            ThmeseV: null,
            pagecount: 1,
            trueaccount: null,
            products_page_count: 1,
            isActive: false,
            activeTab: 1,
            resetpass: 0,
            paymentlist: null,
            checkcredit: false,
            refer: 1,
            showmodal: false,
            historylist: [],
            formData: {}, // Contains login form data
            errors: {}, // Contains login field errors
            formSubmitted: false, // Indicates submit status of login form
            loading: true, // Indicates in progress state of login form
            tblprofile: [],
            userid: null,
            afficiate: [],
            modalx: false,
            cashoutSet: [],
            modal: false,
            linkaff: "",
            point: 0,
            depositamount: 0,
            maxwithdrawstatus: 0,
            useradvice: [],
            afficiatetoday: [],
            afficiateall: [],
            balance: 0,
            counter: 300,
            qrcode: null,
            qrcodecheck: false,
            loginstate: null,
            firstname: null,
            lastname: null,
            activeTab: 1,
            alert: null,
            modalOpen: false,
            handleClose: false,
            proderedeemlist: [],
            token: window.localStorage.getItem("token"),
            type: "",
            prolistx: [],
            prodetail: [],
            username: "",
            tabselect: 0,
            showpassnew: false,
            showpasscf: false,
            showpassold: false,
            amount: "",
            remark: "",
            rankpic: "1.jpeg",
            rankname: null,
            rankob: null,
            rankpoint: 0,
            limit: null,
            name: "",
            password: "",
            oldpassword: "",
            passwordcf: "",
            left: false,
            pathname: "",
            linelink: "",
            mainsetting: [],
            rewardlist: [],
            activePage: 1,
            checkboxcookie: false,
            isActive: false,
            formData: {}, // Contains login form data
            errors: {}, // Contains login field errors
            formSubmitted: false, // Indicates submit status of login form
            loading: true, // Indicates in progress state of login form
            pagecount: 1,
            username: null,
            settingwheel: "",
            settingcheckin: "",
            userid: null,
            phoneNumber: "",
            balance: 0,
            mainacc: null,
            paymentgateway: null,
            tabselectsec: 0,
            qrcode: null,
            stateregis: 1,
            checkboxacc: 0,
            products_page_count: 1,
            loginstate: false,
            fullname: null,
            lname: null,
            link: "",
            alert: null,
            depositstate: 0,
            stateforget: 1,
            depositamount: 0,
            stateopterror: "",
            btnisActive: true,
            otpphone: "",
            token: window.localStorage.getItem("token"),
            accnumber: null,
            accnumbertxt: null,
            withdrawamount: 0,
            rankpoint: 0,
            changepassword: false,
            linelink: "",
            errortext: "",
            trueaccount: null,
            trueaccount: null,
            datas: null,
            otpphoneforget: "",
            affpercent: 0,
            counter: 300,
            userrecomend: "",
            historylist: [],
            useradvice: [],
            cashoutlist: [],
            tblnextrank: [],
            tblrankall: [],
            maxwithdrawstatus: 0,
            tblprofile: [],
            prodetail: [],
            oldpassword: "",
            linkaff: "",
            webnamex: "",
            inviteSet: "",
            truegiftlink: "",
            proderedeem: [],
            qrcode: null,
            proderedeemlist: [],
            buttoncliam: false,
            limit: null,
            rankpic: "1.jpeg",
            rankname: null,
            rankob: null,
            cashoutSet: [],
            tblPopupMenu1: [],
            tblPopupMenu2: [],
            tblPopupMenu: null,
            termAndCondition: false,
            errorstatus: false,
        }
    }
    copyCode = (text) => {
        navigator.clipboard
            .writeText(text)
            .then(() => {
                this.notify("warning", 'CopyCode!!!');
            })
            .catch((err) => {
                // console.log(err.message);
            });

    };

    promotionlist = () => {
        instance.post("/api/v1/getpromotion", {
            System: Systems,
        }).then(async (res) => {
            if (res.data.status === 200) {
                this.setState({
                    prolistx: res.data.message,
                });
            }
        }).catch(async (err) => {
            //   console.log(err);

            if (err.response.status === 401 || err.response.status === 403) {
                localStorage.clear();
                await this.notify("warning", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                window.location.href = '/';
            }
        });
    }
    checklogin() {
        var token = localStorage.getItem('auth_token');

        console.log(11111111, token);
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            this.rechecklogin(Username, token);
        }
        else {
            this.setState({
                loginstate: false,
            });
        }
    }


    async recheccredit(evt) {

        evt.currentTarget.className += " fa-spin";
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        this.setState({
            checkcredit: true,
            userid: decoded.message.playerid,
            username: decoded.message.playerid,
            firstname: decoded.message.firstname,
            lastname: decoded.message.lastname,
            loginstate: true,
        });
        try {
            // console.log(2);
            await instance.post("/api/v1/checkpoint", {
                userid: Username,
                System: Systems,
                Function: 'recheccredit-App.js'
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                if (res.data.status === 200) {
                    localStorage.setItem('auth_token', res.data.token)
                    this.setState({
                        accnumber: res.data.message.accnumber,
                        userid: res.data.message.member_id,
                        username: res.data.message.playerid,
                        fullname: res.data.message.firstname,
                        point: res.data.message.Point,
                        balance: res.data.databalance,
                        loginstate: true,
                        checkcredit: false,
                    });
                }
                else if (res.data.status === 401) {
                    //   console.log(res.data);
                    localStorage.clear();
                    await this.notify("warning", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                    window.location.href = '/';
                }

            }).catch(async (err) => {
                // console.log(err);
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await this.notify("warning", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                    window.location.href = '/';
                }
            });
        }
        catch (ex) {
            ////////console.log(ex);
        }
    }
    callpercent(gameid) {
        //console.log(this.state.typepage)
        const date = new Date();
        let number = 30 + Math.floor(Math.random() * (100 - 30));
        var tokenx = localStorage.getItem('percentgame');
        let tagpercentlist = [];
        let tagpercent = [];
        if (tokenx != null) {
            const listx = JSON.parse(tokenx);
            var listIndex = listx.filter(x => x.id === gameid);
            // console.log(57, listIndex);
            if (listIndex.length == 0) {
                //  console.log(gameid, 59);
                let list = {
                    id: gameid,
                    percent: number,
                    datetime: date
                }
                listx.push(list)
                tagpercent.push(listIndex)
                localStorage.setItem('percentgame', JSON.stringify(listx))
            } else {
                tagpercent = listIndex
                var created = new Date();
                const startDate = moment(listIndex[0].datetime);
                const timeEnd = moment(created);
                const diff = timeEnd.diff(startDate);
                const diffDuration = moment.duration(diff);
                // console.log(777, diffDuration.minutes(), gameid)
                if (diffDuration.minutes() > 30) {
                    listx.filter(x => x.id === gameid).map(function (obj) {
                        obj.number = number
                        obj.datetime = date
                        return obj
                    })
                    localStorage.setItem('percentgame', JSON.stringify(listx))
                    console.log("finish", gameid)
                }
            }
        }
        else {
            let list = {
                id: gameid,
                percent: number,
                datetime: date
            }
            tagpercent.push(list)
            tagpercentlist.push(list)
            localStorage.setItem('percentgame', JSON.stringify(tagpercentlist))
        }
        console.log(92, tagpercent[0], tagpercentlist.length)
        if (this.state.typepage != "casino" && this.state.typepage != "sport") {
            let percent = tagpercent[0].percent
            if (percent == undefined) percent = number
            console.log(11, percent)
            let pop = (
                <div>
                    <div className="progress position-progress mt-1 position-progress-g"
                        role="progressbar"
                        aria-label="Example with label"
                        aria-valuenow={percent}
                        aria-valuemin={0}
                        aria-valuemax={100}
                    >
                        <div
                            className="progress-bar bg-rate-persent text-web"
                            style={{
                                width: parseInt(percent) + "%",
                                background: (percent > 0 && percent < 50) ? "rgb(254, 215, 25)" : (percent >= 50 && percent < 70) ? " rgb(2, 119, 189)" : "rgb(37, 155, 36)"
                            }}
                        />
                    </div>
                    <div className="text-win-rate">
                        <small className="text-size-win-rate">
                            อัตราชนะ
                        </small>
                        <b className="p-1 text-size-win-rate-number">
                            {percent}%
                        </b>
                    </div>
                </div>
            )
            return pop

        }
        else {
            return ""
        }


    }
    async opencliamcashout(evt, cityName) {
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        await instance.post("/api/v1/cliamcashout", {
            userid: Username,
            System: Systems,
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
            if (res.data.status === 200) {
                var decoded = jwt_decode(token);
                var Username = decoded.message.playerid;
                this.rechecklogin(Username, token);
                await this.notify("success", 'ทำรายการรับเงินเรียบร้อย');
            }
            else if (res.data.status === 201) {
                await this.notify("error", 'ไม่สามารถทำรายการได้ ไม่มียอดเงิน');
                return false;
            }
            else if (res.data.status === 202) {
                await this.notify("error", 'ไม่สามารถทำรายการได้');
                return false;
            }

        }).catch(async (err) => {
            // console.log(err);
            if (err.response.status === 401 || err.response.status === 403) {
                localStorage.clear();
                await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                window.location.href = '/';
            }
        });
    }
    onChangexxxxx = (checked) => {
        console.log(128, checked)
        if (checked == 1) {
            if (this.state.showpassold) {
                this.setState({ showpassold: false });
            }
            else {
                this.setState({ showpassold: true });
            }
        }
        else if (checked == 2) {
            if (this.state.showpassnew) {
                this.setState({ showpassnew: false });
            }
            else {
                this.setState({ showpassnew: true });
            }
        }
        else if (checked == 3) {
            if (this.state.showpasscf) {
                this.setState({ showpasscf: false });
            }
            else {
                this.setState({ showpasscf: true });
            }
        }
    }

    onChangex = event => {
        // console.log("event", event.target.name);


        if (event.target !== undefined) {
            let nam;
            let val;
            if (event.target.name === undefined) {
                nam = event.name;
                val = event.value;
            } else {
                nam = event.target.name;
                val = event.target.value;
            }
            this.setState({ [nam]: val });
        }
    };

    checkurl = async (e, url) => {
        const pathname = url.split("/")
        //  console.log(210, url.split("/"));
        if (pathname.length > 1) {
            if (!this.state.loginstate && pathname[1] == "listgameall") {
                this.setState({
                    tabselect: 23,
                });
                return;
            }
            else {
                window.history.pushState(null, null, url);
                this.setState({
                    modalx: false,
                    modal: false,
                });
                if (pathname[1] == "") {
                    console.log(250, pathname[1]);
                    this.setState({
                        tabselect: 0,
                    });
                }
                else if (pathname[1] == "casino") {
                    this.setState({
                        tabselect: 10,
                    });
                }
                else if (pathname[1] == "gamehit") {
                    this.setState({
                        tabselect: 11,
                    });
                }
                else if (pathname[1] == "fishing") {
                    this.setState({
                        tabselect: 12,
                    });
                }
                else if (pathname[1] == "slot") {
                    console.log(101, pathname);
                    this.setState({
                        tabselect: 13,
                    });
                }
                else if (pathname[1] == "sport") {
                    this.setState({
                        tabselect: 14,
                    });
                }
                else if (pathname[1] == "loss") {
                    this.setState({
                        tabselect: 25,
                    });
                }

                else if (pathname[1] == "event") {
                    this.setState({
                        tabselect: 16,
                    });
                }
                else if (pathname[1] == "lotto") {
                    this.setState({
                        tabselect: 17,
                    });
                }
                else if (pathname[1] == "withdraw") {
                    if (this.state.loginstate) {
                        this.setState({
                            tabselect: 2,
                        });
                    }
                    else {
                        this.setState({
                            tabselect: 0,
                        });
                    }
                }
                else if (pathname[1] == "deposit") {
                    this.setState({
                        tabselect: 1,
                        tabselectdeposit: 1,
                    });
                }
                else if (pathname[1] == "statement") {
                    this.setState({
                        tabselect: 3,
                    });
                }
                else if (pathname[1] == "profile") {
                    this.setState({
                        tabselect: 8,
                    });
                }
                else if (pathname[1] == "register") {
                    this.setState({
                        tabselect: 22,
                    });
                }
                else if (pathname[1] == "signin") {
                    this.setState({
                        tabselect: 23,
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/overview") {
                    this.setState({
                        tabselect: 4,
                        refer: 1
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/member") {
                    this.setState({
                        tabselect: 4,
                        refer: 2
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/income-summary") {
                    this.setState({
                        tabselect: 4,
                        refer: 3
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/share-network") {
                    this.setState({
                        tabselect: 4,
                        refer: 4
                    });
                }
                else if (pathname[1] == "rebate") {
                    this.setState({
                        tabselect: 5,
                    });
                }
                else if (pathname[1] == "promotion") {
                    this.setState({
                        tabselect: 7,
                    });
                }
                else if (pathname[1] == "listgameall") {
                    let check = await this.getgame(pathname[2], pathname[3], true);
                    console.log(614, check)
                    if (check) {
                        this.setState({
                            tabselect: 15,
                        });
                    }
                }
            }
        }
        else {
            this.setState({
                tabselect: 0,
            });
        }
    }

    async calllisthistory(userid) {
        await instance.post("/api/v1/userwithdrawlist", {
            userid: userid,
            Cat_ID: 0,
            System: Systems,
            page: 1,
            type: 1
        }).then((res) => {
            if (res.data.status === 200) {
                const datas = res.data.message;
                //  //console.log(datas.withdrawlist);
                this.setState({
                    historylist: datas.withdrawlist
                });

            }
            else {
                // this.CheckThisGoalError();
            }
        });

    }
    confirmdeposit = async (e, num) => {
        console.log(493, num)
        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        if (num === 0) {
            if ((this.state.depositamount >= this.state.limit.min) && (this.state.depositamount <= this.state.limit.max)) {
                if (num === 0) {
                    if (token != null) {
                        Username = decoded.message.playerid;
                        instance.post("/api/v1/getqrcode", {
                            username: Username,
                            System: Systems,
                            amount: this.state.depositamount
                        }, {
                            headers: { Authorization: `Bearer ${token}` }
                        }).then(async (res) => {
                            console.log(res.data.tblpaymentgatewayx)
                            this.setState({
                                mainacc: res.data.mainacc,
                                qrcode: res.data.tblpaymentgatewayx.QRcode,
                                paymentlist: res.data.tblpaymentgatewayx,
                                counter: 300,
                                qrcodecheck: true,
                            });
                            await this.notify("success", 'กรุณาสแกน qrcode ภายใน 5 นาที');
                        });

                    }

                    this.setState({
                        depositstate: 1
                    });
                }
            }
            else {
                await this.notify("warning", 'เติมขั้นต่ำ ' + this.state.limit.min + ' บาท สูงสุด ' + this.state.limit.max + ' ');

            }
        }
        else if (num === 1) {
            this.setState({
                depositstate: 1
            });
        }

        else if (num === 5) {
            document.getElementById("truemonney").click()
            //deposittruemoneyModal
        }
        else {
            this.setState({
                depositstate: 0
            });
        }



    }
    onChange = async (event) => {
        console.log(event);
        if (event.target !== undefined) {
            let nam;
            let val;
            if (event.target.name === undefined) {
                nam = event.name;
                val = event.value;
            } else {
                nam = event.target.name;
                val = event.target.value;
            }
            if (nam === "withdrawamount") {
                if (this.state.maxwithdrawstatus === 1) {
                    this.setState({ [nam]: this.state.balance });
                    await this.notify("warning", 'บังคับถอนยอดทั้งหมด');
                }
                else if (Number(val) <= Number(this.state.balance)) {
                    this.setState({ [nam]: val });
                }
                else {
                    await this.notify("warning", 'ยอดถอนของท่านไม่เพียงพอในการถอน');

                }
            } else {
                this.setState({ [nam]: val });
            }

        }
    };
    submitwithdraw = async (e) => {
        console.log(this.state.withdrawamount, this.state.balance);
        if (parseFloat(this.state.withdrawamount) <= parseFloat(this.state.balance)) {
            if (parseFloat(this.state.withdrawamount) >= 10) {
                var token = localStorage.getItem('auth_token');
                if (token != null) {
                    var decoded = jwt_decode(token);
                    var Username = decoded.message.playerid;
                    await instance.post("/api/v1/userwithdraw", {
                        User_id: Username,
                        System: Systems,
                        amount: this.state.withdrawamount
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    }).then(async (res) => {
                        console.log(res.data);
                        if (res.data.status === 200) {
                            await this.notify("success", 'รายการถอนเรียบร้อย');
                            this.checkurl(e, "/statement")

                        }
                        else if (res.data.status === 203) {
                            await this.notify("error", 'ท่านติด Turnover อีก ' + res.data.amountturnover + " บาท");

                        }
                        else if (res.data.status === 207) {
                            await this.notify("error", 'ขั้นต่ำในการถอน ' + res.data.maxwithdraw + " บาท");

                        }
                        else {
                            await this.notify("error", "ไม่สามารถทำรายการถอนได้ โปรดแจ้งพนักงาน");
                        }
                    });
                }
                else {
                    await this.notify("error", 'รายการถอนมีปัญหา โปรดติดต่อพนักงาน');
                }
            }
            else {
                await this.notify("warning", 'ขั้นต่ำในการถอน 50 บาท');
            }
        }
        else {
            await this.notify("warning", 'ยอดถอนของท่านไม่เพียงพอในการถอน');
        }

    }
    addDefaultSrc(ev, listitem) {
        const origin = listitem.split("http");
        //  console.log("img", origin.length )
        if (origin.length > 1) {
            return listitem;
        }
        else {
            return "https://ardmhzelxcmj.ocrazeckyunc.com" + listitem

        }

    }
    resetpassword = async (e, type) => {
        e.preventDefault();
        const { phoneNumber, fname, password, oldpassword, passwordcf } = this.state;
        console.log(type, password, oldpassword, passwordcf);
        var token = localStorage.getItem('auth_token');
        if (password === passwordcf) {
            var Username = null;
            var decoded = null;
            if (type === 1 && token != null) {
                decoded = jwt_decode(token);
                Username = decoded.message.playerid;
                instance.post("/api/v1/resetpassword", {
                    username: Username,
                    oldpass: oldpassword,
                    System: Systems,
                    newpass: password,
                    type: type
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                }).then(async (res) => {
                    if (res.data.status === 200) {
                        await this.notify("success", 'เปลี่ยนพาสเวิดเรียบร้อย');
                    }
                    else if (res.data.status === 201) {
                        await this.notify("error", 'คุณใส่รหัสเก่าผิดพลาด');
                    }
                    else if (res.data.status === 203) {
                        await this.notify("error", 'มีข้อผิดพลาด โปรดทำรายการอีกครั้ง');
                    }
                    else if (res.data.status === 202) {
                        await this.notify("error", 'คุณใช้พาสเวิดเดิม');
                    }
                });
            }
            else if (type === 2) {
                instance.post("/api/v1/resetpassword", {
                    username: phoneNumber,
                    oldpass: oldpassword,
                    newpass: password,
                    System: Systems,
                    type: type
                }).then(async (res) => {
                    if (res.data.status === 200) {
                        await this.notify("success", 'เปลี่ยนพาสเวิดเรียบร้อย');
                    }
                    else if (res.data.status === 201) {
                        await this.notify("error", 'คุณใส่รหัสเก่าผิดพลาด');
                    }
                    else if (res.data.status === 203) {
                        await this.notify("error", 'มีข้อผิดพลาด โปรดทำรายการอีกครั้ง');
                    }
                    else if (res.data.status === 202) {
                        await this.notify("error", 'คุณใช้พาสเวิดเดิม');
                    }
                });
            }
            else if (type === 3) {
                instance.post("/api/v1/resetpassword", {
                    username: phoneNumber,
                    oldpass: oldpassword,
                    newpass: password,
                    System: Systems,
                    type: type
                }).then(async (res) => {
                    if (res.data.status === 200) {
                        await this.notify("success", 'เปลี่ยนพาสเวิดเรียบร้อย');
                    }
                    else if (res.data.status === 201) {
                        await this.notify("error", 'คุณใส่รหัสเก่าผิดพลาด');
                    }
                    else if (res.data.status === 203) {
                        await this.notify("error", 'มีข้อผิดพลาด โปรดทำรายการอีกครั้ง');
                    }
                    else if (res.data.status === 202) {
                        await this.notify("error", 'คุณใช้พาสเวิดเดิม');
                    }
                });
            }
        }
        else {
            await this.notify("error", 'คุณใส่พาสเวิดไม่ตรงกัน');
        }
    }
    async opencliaminvite(evt, cityName) {
        console.log(cityName);
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        await instance.post("/api/v1/cliaminvite", {
            userid: Username,
            System: Systems,
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
            if (res.data.status === 200) {
                var decoded = jwt_decode(token);
                var Username = decoded.message.playerid;
                this.rechecklogin(Username, token);
                await this.notify("success", 'ทำรายการรับเงินเรียบร้อย');
            }
            else if (res.data.status === 201) {
                await this.notify("error", 'ไม่สามารถทำรายการได้ ไม่มียอดเงิน');
                return false;
            }
            else if (res.data.status === 202) {
                await this.notify("error", 'ไม่สามารถทำรายการได้');
                return false;
            }

        }).catch(async (err) => {
            // console.log(err);
            if (err.response.status === 401 || err.response.status === 403) {
                localStorage.clear();
                await this.notify("warning", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                window.location.href = '/';
            }
        });
    }
    handleClick = async (e, price) => {
        console.log(price);
        if (price <= this.state.balance) {
            this.setState({
                withdrawamount: price
            });
        }
        else {
            await this.notify("warning", 'ยอดถอนของท่านไม่เพียงพอในการถอน');
        }
    }
    handleClickreposit = async (e, price) => {
        this.setState({
            depositamount: price
        });
    }
    redeempro = async (e, proid) => {
        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        //console.log(Username, proid);
        if (token != null) {
            this.setState({
                username: Username,
            });
            await instance.post("/api/v1/redeempromotion", {
                userid: Username,
                System: Systems,
                Proid: proid,
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                //console.log(res.data.status)
                if (res.data.status === 200) {
                    this.setState({
                        showmodal: false,
                    })
                }
                else if (res.data.status === 201) {
                    await this.notify("error", 'ท่านไม่เข้าเงื่อนใขโปรโมชั่นนี้');
                    e.preventDefault();
                    return false;
                }
                else if (res.data.status === 204) {
                    await this.notify("error", 'ท่านใช้สิทธวันนี้ครบแล้ว');
                    e.preventDefault();
                    return false;
                }
                else if (res.data.status === 202) {
                    await this.notify("error", 'ท่านใช้โปรมั่นชั่นนี้ไปแล้ว');
                    e.preventDefault();
                    return false;
                }

            }).catch(async (err) => {
                // console.log(err);
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                    window.location.href = '/';
                }
            });
        }
    }
    redeem = (e, gameIdx, partner) => {
        var userAgent = navigator.userAgent
        this.checklogin();
        if (!this.state.loginstate) {
            //   return document.getElementById("loginmode").click();
            return this.notify("error", 'คุณยังไม่ได้ทำการล๊อคอิน');
        }
        if (this.state.username !== null) {
            instance.post("/api/v1/tablauncher", {
                gameId: gameIdx,
                partner: partner,
                playerUsername: this.state.username,
                isMobile: isMobile,
                System: Systems,
                demo: false
            })
                .then((res) => {
                    if (res.data.status === 200) {
                        console.log(res.data.message);
                        var test = res.data.message.launcher
                        if (test !== undefined) {
                            if (/iPad|iPhone|Macintosh|iPod/.test(userAgent) && !window.MSStream) {
                                window.location.href = test.mobile;
                            }
                            else {
                                if (!isMobile) window.open(test.desktop, '_blank', 'height=1000,width=1000');
                                else window.open(test.mobile);
                            }
                        }
                        else if (test === undefined) {
                            Swal.fire({
                                title: 'error!',
                                text: 'ขณะนี้เกมมีปัญหากรุณารอซักครู่',
                                icon: 'error',
                                confirmButtonText: 'ตกลง'
                            })
                        }
                    }
                    else {
                        //  this.CheckThisGoalError();
                    }
                });
        }
        else {

        }


    }

    couponredeem = async (e, index) => {
        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            await instance.post("/api/v1/usercoupon", {
                User_id: Username,
                System: Systems,
                couponkey: this.state.couponkey,
                type: 1
            }).then(async (res) => {
                if (res.data.status === 200) {
                    const datas = res.data.message;
                    await this.notify("success", 'ดำเนินการใช้คูปองเรียบร้อย');
                }
                else {
                    await this.notify("warning", 'ไม่มี Key นี้ในระบบ');
                }
            });
        }
        else {
            await this.notify("warning", 'คุณไม่ได้ล๊อคอิน');
        }

    }

    copy = async (e, accnumber) => {
        toast.success("คัดลอกเรียบร้อย", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });

        navigator.clipboard.writeText(accnumber)
    }
    async callgetthemesv(Systems) {
        await instance.post("/api/v1/getthemesv", {
            System: Systems,
        }).then((res) => {
            if (res.data.status === 200) {
                document.body.setAttribute("data-theme", res.data.ThmeseV)
                this.setState({
                    ThmeseV: res.data.ThmeseV
                });

            }
            else {
                // this.CheckThisGoalError();
            }
        });

    }
    async getgame(typepage, partner, click = false) {
        return await instance.post("/api/v1/tabgamelist", {
            state: "999",
            System: Systems,
            partner: partner,
            playerid: this.state.username,
            game: typepage,
        }).then(async (res) => {
            console.log(803, res.data);
            if (res.data.status === 200) {
                if (res.data.message.length > 1 || !click) {
                    this.setState({
                        listitallgame: res.data.message
                    });
                    return true;
                }
                else {
                    this.redeem(null, "lobby", partner)
                    return false;
                }
            }
            else {
                return false;
            }
        });
    }
    async getcallprovidor() {
        await instance.post("/api/v1/tabgamelist", {
            state: "2",
            System: Systems,
        }).then((res) => {
            if (res.data.status === 200) {
                this.setState({
                    categorylist: res.data.message
                });
            }
        });

        await instance.post("/api/v1/tabgamelist", {
            state: "3",
            System: Systems,
        }).then((res) => {
            if (res.data.status === 200) {
                this.setState({
                    slotlist: res.data.message
                });
            }
        });

        await instance.post("/api/v1/tabgamelist", {
            state: "5",
            System: Systems,
        }).then((res) => {
            if (res.data.status === 200) {
                this.setState({
                    sportlist: res.data.message
                });
            }
        });

        await instance.post("/api/v1/tabgamelist", {
            state: "8",
            System: Systems,
        }).then((res) => {
            if (res.data.status === 200) {
                this.setState({
                    fishinglist: res.data.message
                });
            }
        });
    }
    async componentDidMount() {
        this.checklogin();
        this.getcallprovidor();
        await this.callgetthemesv(Systems);
        this.promotionlist();
        try {
            const pathname = window.location.pathname.split("/")
            // console.log(989999, pathname.length);
            await instance.post("/api/v1/mainsetting", {
                System: Systems,
            }).then((res) => {
                if (res.data.status === 200) {
                    const datas = res.data.message;
                    var min = res.data.tblcatagoryx[0].limitdeposit;
                    var max = res.data.tblcatagoryx[0].maxdeposit;
                    var maxwithdrawstatus = res.data.tblcatagoryx[0].withdrawmax
                    var limit = { min, max }
                    this.setState({
                        maxwithdrawstatus: maxwithdrawstatus,
                        linelink: datas[1].value,
                        webnamex: datas[7].value,
                        System: res.data.tblcatagoryx[0].System,
                        cashoutSet: res.data.tblcashoutsetting[0],
                        inviteSet: res.data.tblinvitedsetting[0],
                        datas: datas,
                        limit: limit,
                    });
                }
                else {
                    // this.CheckThisGoalError();
                }
            });
            //   console.log(455, pathname[1] + "/" + pathname[2])
            await instance.post("/api/v1/gettrue", {
                userid: Username,
                System: Systems,
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                if (res.data.status === 200) {
                    console.log(res);
                    this.setState({
                        trueaccount: res.data.message.tbltruewallet[0],
                    });

                }
            }).catch(async (err) => {
            });
            if (pathname.length > 1) {
                console.log(pathname);
                if (pathname[1] == "casino") {
                    this.setState({
                        tabselect: 10,
                    });
                }
                else if (pathname[1] == "gamehit") {

                    this.setState({
                        tabselect: 11,
                    });
                }
                else if (pathname[1] == "fishing") {
                    this.setState({
                        tabselect: 12,
                    });
                }
                else if (pathname[1] == "loss") {
                    this.setState({
                        tabselect: 25,
                    });
                }
                else if (pathname[1] == "slot") {
                    this.setState({
                        tabselect: 13,
                    });
                }
                else if (pathname[1] == "register") {
                    this.setState({
                        tabselect: 22,
                    });
                }
                else if (pathname[1] == "signin") {
                    this.setState({
                        tabselect: 23,
                    });
                }
                else if (pathname[1] == "sport") {
                    this.setState({
                        tabselect: 14,
                    });
                }
                else if (pathname[1] == "event") {
                    this.setState({
                        tabselect: 16,
                    });
                }
                else if (pathname[1] == "lotto") {
                    this.setState({
                        tabselect: 17,
                    });
                }
                else if (pathname[1] == "withdraw") {
                    // console.log(1232323)
                    if (this.state.loginstate) {
                        this.setState({
                            tabselect: 2,
                        });
                    }
                    else {
                        this.setState({
                            tabselect: 0,
                        });
                    }
                }
                else if (pathname[1] == "deposit") {
                    if (this.state.loginstate) {
                        this.setState({
                            tabselect: 1,
                            tabselectdeposit: 1,
                        });
                    }
                    else {
                        this.setState({
                            tabselect: 0,
                        });
                    }
                }
                else if (pathname[1] == "statement") {
                    if (this.state.loginstate) {
                        this.setState({
                            tabselect: 3,
                        });
                    }
                    else {
                        this.setState({
                            tabselect: 0,
                        });
                    }
                }
                else if (pathname[1] == "profile") {
                    if (this.state.loginstate) {
                        this.setState({
                            tabselect: 8,
                        });
                    }
                    else {
                        this.setState({
                            tabselect: 0,
                        });
                    }
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/overview") {
                    this.setState({
                        tabselect: 4,
                        refer: 1
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/member") {
                    console.log(63855555);
                    this.setState({
                        tabselect: 4,
                        refer: 2
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/income-summary") {
                    this.setState({
                        tabselect: 4,
                        refer: 3
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/share-network") {
                    this.setState({
                        tabselect: 4,
                        refer: 4
                    });
                }
                else if (pathname[1] == "rebate") {
                    this.setState({
                        tabselect: 5,
                    });
                }
                else if (pathname[1] == "promotion") {
                    this.setState({
                        tabselect: 7,
                    });
                }
                else if (pathname[1] == "listgameall") {
                    let check = await this.getgame(pathname[2], pathname[3]);
                    if (check) {
                        this.setState({
                            tabselect: 15,
                        });
                    }
                }
            }
            try {
                console.log(1625656556);
                var token = localStorage.getItem('auth_token');
                if (token != null) {
                    var decoded = jwt_decode(token);
                    var Username = decoded.message.playerid;
                    await this.rechecklogin(Username, token);
                    this.setState({
                        userid: decoded.message.playerid,
                        username: decoded.message.playerid,
                        firstname: decoded.message.firstname,
                        lastname: decoded.message.lastname,
                        loginstate: true,
                    });
                }
                else {
                    this.setState({
                        loginstate: false,
                    });
                }


            }
            catch (error) {
                console.log(185222, error);
            }
        }
        catch (error) {
            console.log(185222, error);
        }
        if (token != null) {
            var decoded = jwt_decode(token);
            let Username = decoded.message.playerid;
            instance.post("/api/v1/getqrcode", {
                username: Username,
                System: Systems,
                amount: 50
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                //////console.log(res.data.picture)
                console.log(16888, res.data.mainacc)
                this.setState({
                    mainacc: res.data.mainacc,
                    paymentgateway: res.data.tblpaymentgatewayx,
                });
            });
        }
    }


    checktab(e, index) {

        if (index == 2 && this.state.tabselectsec == 1) {

        }
        else {
            console.log(1279, index, this.state.tabselectsec, this.state.qrcode);
            if (index == 2 && this.state.qrcode != null) {
                this.setState({
                    tabselectdeposit: 0,
                    tabselectsec: 1,
                });
            }
            else {
                this.setState({
                    tabselectdeposit: index,
                    tabselectsec: 0,
                });
            }
        }
    }
    openAccout(evt, cityName) {
        var i, tabcontent, tablinks;
        tabcontent = document.getElementsByClassName("x-menu-account-list-sidebar");
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].className += " -open";
        }
    }
    async checkuseradvice() {
        instance.post("/api/v1/checkuseradvice", {
            User_id: this.state.username,
            page: 1,
            System: Systems,
        }).then((res) => {
            if (res.data.status === 200) {
                console.log(res.data.message.useradvicelist);
                this.setState({
                    useradvice: res.data.message.useradvicelist
                });
            }
            else {
                // console.log(res.data);
                // this.CheckThisGoalError();
            }
        });
    }

    openAccoutcan(evt, cityName) {
        var i, tabcontent, tablinks;
        tabcontent = document.getElementsByClassName("x-menu-account-list-sidebar");
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].className = "x-menu-account-list-sidebar";
        }
    }

    async rechecklogin(Username, token) {

        try {
            console.log(45555555555555555);
            const search = window.location.href;
            const paramx = new URLSearchParams(search);
            // const space = search.split("/")
            const space = window.location.host
            var userhash = md5(Username);
            //  const linkaff = "https://pgline88.com/?register=" + userhash;
            const linkaff = "https://" + space + "/register?reg=" + userhash;
            instance.post("/api/v1/checkpoint", {
                userid: Username,
                System: Systems,
                Function: 'rechecklogin-navbar.js'
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                //  console.log(res.data);

                if (res.data.status === 200) {
                    this.calllisthistory(Username);
                    localStorage.setItem('auth_token', res.data.token)
                    console.log(1067, res.data.userafftoday, res.data.useraffall);
                    this.setState({
                        rankpic: res.data.tblrank.image,
                        rankname: res.data.tblrank.name,
                        linkaff: linkaff,
                        rankob: res.data.tblrank,
                        rankpoint: res.data.rankpoint,
                        accnumber: res.data.message.accnumber,
                        userid: res.data.message.member_id,
                        tblprofile: res.data.message,
                        username: res.data.message.playerid,
                        fname: res.data.message.firstname,
                        point: res.data.message.Point,
                        balance: res.data.databalance,
                        afficiatetoday: res.data.userafftoday,
                        afficiateall: res.data.useraffall,
                        loginstate: true,
                    });
                }
                else if (res.data.status === 401) {
                    localStorage.clear();
                    await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                    window.location.href = '/';
                }

            }).catch(async (err) => {
                console.log(err)
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                    window.location.href = '/';
                }
            });
        }
        catch (ex) {
            //////console.log(ex);
        }

    }
    checkpro = async (e, proid) => {
        console.log(248, proid);
        var Username = "";
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            Username = decoded.message.playerid;
        }
        await instance.post("/api/v1/checkpromotion", {
            userid: Username,
            System: Systems,
            Proid: proid,
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
            console.log(res.data)
            if (res.data.status === 200) {
                //console.log(res.data);
                if (res.data.type === 0) {
                    this.setState({
                        showmodal: true,
                        prodetail: res.data.message.tblpromotions[0],
                    });
                }
                else if (res.data.type === 1) {
                    this.setState({
                        showmodal: true,
                        proderedeem: res.data.message.tblpromotionredeems,
                    });
                }



            }
            else if (res.data.status === 201) {
                this.setState({
                    showmodal: true,
                    prodetail: [],
                    picnonpro: "/media/cache/strip/202109/promotion/7AB3F352-6DE2-44CC-A5FC-D4359FCB2122.png",
                });

            }
            else if (res.data.status === 202) {
                await this.notify("success", 'ท่านใช้โปรโมชั่นค้างไว้ สามารถเติมเงินได้เลย');
                return false;
            }

        }).catch(async (err) => {
            //   console.log(err);
            if (err.response.status === 401 || err.response.status === 403) {
                localStorage.clear();
                await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                window.location.href = '/';
            }
        });
    }


    validateLogout = (e) => {
        localStorage.removeItem('auth_token', '')
        this.setState({
            userid: null,
            username: null,
            password: null,
            firstname: null,
            lastname: null,
            point: null,
            loginstate: false,
        });
    }
    logout = (e) => {
        // e.preventDefault();
        let errors = this.validateLogout();
        if (errors === true) {
            // alert("You are successfully signed in...");
            window.location.reload()
        } else {

            this.setState({
                errors: errors,
                formSubmitted: true
            });
            window.location.reload()
        }
    }
    waitnotify = async () => {
        setTimeout(() => { console.log('World!') }, 5000)
    }
    notify = async (mode, msg) => {
        console.log(mode, msg);
        if (mode == "success") {
            await toast.success(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "warning") {
            await toast.warning(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "error") {
            await toast.error(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "info") {
            await toast.info(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        await this.waitnotify();
    }
    async opencliamcashout(evt, cityName) {
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        await instance.post("/api/v1/cliamcashout", {
            userid: Username,
            System: Systems,
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
            if (res.data.status === 200) {
                var decoded = jwt_decode(token);
                var Username = decoded.message.playerid;
                this.rechecklogin(Username, token);
                this.notify("success", 'ทำรายการรับเงินเรียบร้อย');

            }
            else if (res.data.status === 201) {
                await this.notify("error", 'ไม่สามารถทำรายการได้ ไม่มียอดเงิน');
                return false;
            }
            else if (res.data.status === 202) {
                await this.notify("error", 'ไม่สามารถทำรายการได้');
                return false;
            }

        }).catch(async (err) => {
            // console.log(err);
            if (err.response.status === 401 || err.response.status === 403) {
                localStorage.clear();
                await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                window.location.href = '/';
            }
        });
    }
    render() {
        const { pathname, categorylist, fishinglist, sportlist, slotlist, listitallgame } = this.state
        const { loginstate, userid, username, point, firstname, lastname, balance, proderedeemlist, linkaff, tblprofile, limit } = this.state
        const { accnumber, paymentgateway, mainacc, trueaccount } = this.state
        var limits = limit
        var accnumberx;
        console.log(3399, loginstate);
        if (accnumber != null) {
            accnumberx = accnumber[0];
        }
        console.log(1326, categorylist);
        return (
            <>
                <nav id="navbar" className="x-header navbar navbar-expand -logged py-0 back-to-top-btn">
                    <div className="container-fluid align-items-center h-100 position-relative">
                        <div id="headerBrand">
                            <a
                                onClick={(e) => {
                                    this.setState({
                                        modalx: true
                                    });
                                }}
                                className="btn navbar-brand"
                                style={{
                                    cursor: "pointer",
                                    width: 20,
                                    color: "rgba(95, 117, 223, 0) !important"
                                }}
                            >
                                <div
                                    onClick={(e) => {
                                        this.setState({
                                            modalx: true
                                        });
                                    }}
                                    role="button"
                                    className="menu_icon"
                                    style={{ top: "-25px", left: "-15px" }}
                                >
                                    <span className="one" />
                                    <span className="two" />
                                    <span className="three" />
                                </div>
                            </a>
                            <div className="-branding-inner-wrapper">
                                {/**/}
                                <a className="navbar-brand text-white-v1" onClick={(e) => {
                                    this.checkurl(e, "/")
                                }} role="button">
                                    <img
                                        src="/build/web/igame-index-lobby-wm/img/logo.png?v=1"
                                        className="w-logo-web-w-v147"
                                        alt=""
                                    />
                                </a>
                            </div>
                        </div>
                        <div id="headerContent">
                            <ul className="nav -menu-wrapper -logged">
                                <li className="nav-item">
                                    <a
                                        role='button'
                                        onClick={(e) => {
                                            this.checkurl(e, "/refer/overview")
                                        }}
                                        className="nav-link -promotion"
                                        target="_self"
                                    >
                                        <div className="-img-wrapper p-3">
                                            <img
                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5b484701-23cf-4a1e-a37b-251dd801a000/public"
                                                className="-icon img-menu-navbar"
                                                alt="Menu icon promotion"
                                            />
                                        </div>
                                        <div className="-text">เเนะนำเพื่อน</div>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a
                                        role='button'
                                        onClick={(e) => {
                                            this.checkurl(e, "/loss")
                                        }}
                                        className="nav-link -promotion" target="_self">
                                        <div className="-img-wrapper p-3">
                                            <img
                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/d19594c3-f5b7-4544-ce8c-b923b8f13200/public"
                                                className="-icon img-menu-navbar"
                                                alt="Menu icon promotion"
                                            />
                                        </div>
                                        <div className="-text">คืนยอดเสีย</div>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a
                                        role='button'
                                        onClick={(e) => {
                                            this.checkurl(e, "/event")
                                        }}
                                        className="nav-link -promotion" target="_self">
                                        <div className="-img-wrapper p-3">
                                            <img
                                                src="https://imagedelivery.net/OxMo058wRPZzbWHctmHqkA/14b1a3cf-e250-4d31-7541-cd39f837d300/public"
                                                className="-icon"
                                                alt="Menu icon promotion"
                                                width={35}
                                                height={35}
                                            />
                                        </div>
                                        <div className="-text">กิจกรรม</div>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a
                                        role='button'
                                        onClick={(e) => {
                                            this.checkurl(e, "/promotion")
                                        }}
                                        className="nav-link -promotion" target="_self">
                                        <div className="-img-wrapper p-3">
                                            <img
                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/907ff1f1-3e6d-4cfc-c89b-1cd216488900/public"
                                                className="-icon img-menu-navbar"
                                                alt="Menu icon promotion"
                                            />
                                        </div>
                                        <div className="-text">โปรโมชั่น</div>
                                    </a>
                                </li>
                            </ul>
                            <div className="navbar-nav">
                                {(loginstate != null) ? (!loginstate) ?
                                    <div className="x-logged">
                                        <div className="-profile-container">
                                            <div>
                                                <div className="d-flex">
                                                    <a
                                                        role='button'
                                                        onClick={(e) => {
                                                            this.checkurl(e, "/signin")
                                                        }}
                                                    >
                                                        <div className="flex-fill m-1" >
                                                            <span className="login-auth p-2 pl-2-1 v-login">
                                                                <b>เข้าสู่ระบบ</b>
                                                            </span>
                                                        </div>
                                                    </a>
                                                    <div className="flex-fill m-1">

                                                        <a role='button'
                                                            onClick={(e) => {
                                                                this.checkurl(e, "/register")
                                                            }}>
                                                            <span className="register-auth p-2 pl-2-1 v-register">
                                                                <b>สมัครสมาชิก</b>
                                                            </span>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    : <div className="x-logged">
                                        <div className="-deposit-container d-none d-lg-block">
                                            <a
                                                onClick={(e) => {
                                                    this.checkurl(e, "/deposit")
                                                }}
                                                className="text-white-v1 js-account-approve-aware btn -btn-deposit"
                                            >
                                                <div className="f-7">ฝากเงิน</div>
                                            </a>
                                        </div>
                                        <div className="-withdraw-container d-none d-lg-block">
                                            <a
                                                onClick={(e) => {
                                                    this.checkurl(e, "/withdraw")
                                                }}
                                                className="text-white-v1 js-account-approve-aware btn -btn-withdraw"
                                            >
                                                <div className="f-7">ถอนเงิน</div>
                                            </a>
                                        </div>
                                        <div className="-profile-container">
                                            <div className="d-none d-lg-block">
                                                <div className="-btn-wrapper">
                                                    <div className="-inner-wrapper">
                                                        <div className="-balance-container">
                                                            <div className="-text-username11 pl-2">{username}</div> &nbsp;
                                                            &nbsp; &nbsp;{" "}
                                                            <div className="-user-balance js-user-balance f-sm-6 f-7">
                                                                <div className="-inner-box-wrapper">
                                                                    <img
                                                                        className="img-fluid -ic-coin"
                                                                        src="https://play.mm88big.com/assets/ic-coin.daf5aefd.png"
                                                                        alt="customer image"
                                                                        width={26}
                                                                        height={21}
                                                                    />
                                                                    <span id="customer-balance" className="js-customer-balance">
                                                                        <span className="-amount"><NumericFormat value={balance} displayType={'text'} thousandSeparator={true} /> {/**/}</span>
                                                                    </span>{" "}
                                                                    &nbsp; {/**/} &nbsp;{" "}
                                                                </div>
                                                                <button
                                                                    type="button"
                                                                    onClick={(e) => {
                                                                        this.recheccredit(e)
                                                                    }}
                                                                    id="btn-customer-balance-reload"
                                                                    className="-btn-balance"
                                                                >
                                                                    <i className="fas fa-sync-alt" />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="x-profile-image">
                                                        <img
                                                            role="button"
                                                            onClick={(e) => {
                                                                this.setState({
                                                                    modal: true
                                                                });
                                                            }}
                                                            className="img-fluid -profile-image"
                                                            src={"/build/web/igame-index-lobby-wm/img/ic-rank-credit-top-01.png"}
                                                            alt="customer image"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="d-lg-none">
                                                <div className="js-ez-logged-sidebar -btn-mobile-wrapper">
                                                    <div className="-inner-wrapper">
                                                        <div className="-balance-container">
                                                            <div className="-text-username">{username}</div>
                                                            <div className="-user-balance js-user-balance f-sm-6 f-7">
                                                                <div className="-inner-box-wrapper">
                                                                    <img
                                                                        className="img-fluid -ic-coin"
                                                                        role="button"
                                                                        src="/assets/ic-coin.daf5aefd.png"
                                                                        alt="customer image"
                                                                        width={26}
                                                                        height={21}
                                                                    />
                                                                    <span id="customer-balance" className="js-customer-balance">
                                                                        <span className="-amount"><NumericFormat value={balance} displayType={'text'} thousandSeparator={true} />  {/**/}</span> &nbsp;{" "}
                                                                        <a role="button"
                                                                            onClick={(e) => {
                                                                                this.recheccredit(e)
                                                                            }}
                                                                            className="-btn-balance"
                                                                            data-target="#customer-balance"
                                                                            id="icon-refresh-credit">
                                                                            <span>
                                                                                <svg
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                    width={15}
                                                                                    height={15}
                                                                                    fill="currentColor"
                                                                                    className="bi bi-arrow-clockwise text-white-v1-web"
                                                                                    viewBox="0 0 16 16"
                                                                                >
                                                                                    <path
                                                                                        fillRule="evenodd"
                                                                                        d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
                                                                                    />
                                                                                    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                                                                                </svg>
                                                                            </span>
                                                                        </a>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="x-profile-image">
                                                        <img
                                                            onClick={(e) => {
                                                                this.setState({
                                                                    modal: true
                                                                });
                                                            }}
                                                            role="button"
                                                            className="img-fluid -profile-image"
                                                            src={"/build/web/igame-index-lobby-wm/img/ic-rank-credit-top-01.png"}
                                                            alt="customer image"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="x-menu-account-list-sidebar -open">
                                                    <div className="x-modal-account-menu-mobile">
                                                        <div className="-modal-profile-mobile d-xl-none d-block">
                                                            <div className="text-right">
                                                                <i className="fas fa-times f-5 js-close-account-sidebar" />
                                                            </div>
                                                            <div className="x-profile-image">
                                                                <img
                                                                    role="button"
                                                                    onClick={(e) => {
                                                                        this.setState({
                                                                            modal: true
                                                                        });
                                                                    }}
                                                                    className="img-fluid -profile-image"
                                                                    src={"/build/web/igame-index-lobby-wm/img/ic-rank-credit-top-01.png"}
                                                                    alt="customer image"
                                                                />
                                                            </div>
                                                            <div className="-balance-container">
                                                                <div className="-text-username">{username}</div>
                                                                <div className="-user-balance js-user-balance f-sm-6 f-7">
                                                                    <div className="-inner-box-wrapper">
                                                                        <img
                                                                            className="img-fluid -ic-coin"
                                                                            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAqqSURBVHgB7VlrbB1HFf5m9nGvr99O8xBx2rRKaHlEgDBCiqooBZUfATW0pakQJWoLEhUQ3vQHSBA1rVRADYgAERIF/iAgCCRaQUEtNEK0RYgmRSXQNFZKEsdJbMf2tZ3r+9jd4czszO7s3nUSqfzck6x3dnb2zHznfHPmzFyglFJKKaWUUkoppZRSSimllG5h9sNrHz5w0+jQ6vvdarUCcMB1BDg1YVTmdDn07HhCfcXkO13v1o6h0XqC7R2bMbrEJw/1oX9gB4aGx6itE+ugF9yFKki9XA1BFxgSfbIHdY/iO/Ql++VMf881AqpgPIXCVbv4wa0u0sPj7CPVk12An7v9W2tGK96LG4bXjTLH1R/qQTA9QPOsBufoQdO9fxDoGTiJlvgQ+9Lmo817f7ZZ9PCfVvuHt6Lak7Zl2njqrrHC1F+mrEbJV3hX8Gz68H2gMjSOcP7tbPe6S8oGBvAwC29y3eoowg4QRsUDsp/t+iXSNdS8AYODz4uHXziB2elREUbD6JCuINSmzYFN9CCnGwXAr2AcVjBG44zBaBMCXEuV/8kA5sQ7zhSdqD0BFhm2G6JqUmjFQpelkWangYX5KjFgi6xXrBJC0jIFhsj63qjT72RbVWdAi7Q7Mxam6zLcRFoH652siyQOMrhwuXnl2gXGWNpRHqiw6YVuI8gBt6O0jvFs50XCsioKRy1sHSwGbXetqlm2Qt7keLjdKMUZF1xXvxeZ/mKrGo9YHhaWl5k1YmMU6VmlUWTZAGMIPSCP/nRkM7ve0Syj58gynCl0GcgA1YM2YzXA2+1uwFJ4hibCAo2UfkaRDVIbJKR3bMso+LFz2sMRul0XEcvaEJvnwe+mNhUCd64XOFQDFgWCYAbu56hZlYZ2eAh4qZoCtTCnoHM0NyCTqSQrOilGU3AIO2dy5gnzFVLL6bJUkpTpikTyHEUhTq0H6ne/CbjumrRN/qJ5Nd+YgtjVpDZtLPx+HOL6WeBmMkJnEdHWOWADzTsKsDhmByLjCGTHkC+rPoJ4/iJKGZsH3Ofz2Z5aNYDDsnOrEGzU1VEYhmhTgAhlRw5bcVAi6mCRL4BVqM1/Xcz+ro7oElFuYBmhcwH+jlrsqqfJs22bgDlHiBXKUajHF8bB9FI9wHJ9tgvwUGvtv6rMOUhzKkLNg6hyYqpRaHVqKJ10hCyo5DnviSg1VMtBc7IFvBFY/+Xr4QxQnnNyCc4Oet8jKe4BR7yUkl36LAPYZePVoIVoYRbtcxMITp/cx746dq4LMPvVrpB9f/dnUF94Ky41P8oi8TxqDsUSsUKnWQ9K2zhN8vAyAVlqoZjSkSLPKncVFn7SRvBqA64E+zSx46U5sJu1d58i7wovx6aomMK2keVYCWx4cfbP8zPnPz47M7XGO3DHQxZNuheDxJd3HfIx0tgfVp1P8UZIgFj2E5Z9jqjDS0ETftVHhVWtVyzXluY70a3RbhCWgGKTi1bQgPexNipbKWM7QZP3cfLy20iHzHDH6XlOxL5hPJdkWPpdHSQvzO5j39v5tZVwrQhYgZax+IEf/yJw+C6vaZTnPrMCilD/ZPrrFGdEpksWey6eEQHm1kxi5CsEVjjo7F+EdxeBXE/TSjKiNUIG6ANmHAswT7Mvk+72Ugo7U/8O+8Z7P385TPxyL9XqebZzH0XgTmY+i/z8Ne05uOdmaZxYI2mkQcv9BKc9xxL6bvfjNfE5RhGc4stGD9FfQkw89gqlhpT/bwriIGToLaLsQCu+XBNPk7Kv4wrCr9SAPfmJRtQJngx5LkraIHR5eq2DpQe302aiukJwQ8ZAEa3HnY11+DcSdZcoSD7DsdwQKpfnpKPa78cG6oTILh3IzmGf5nvoHGYHdizg9QKWErSDV0XGu7mOqSyXo8WqQKuPOl/dnw5QINPOvi+15lH7oB/T8rALVvfhTg2i/jKNe6yD1Z+mMD5N715xkKSvduA0+uWWk/F/4irEvZpGUSf04JtUUfeSpHFMr6+RmnNdkdO07woXAr5bQfRrMhaNwpmvKJqv6VuL+g/msfzmNvxaBc4ERe42jyMwsxJzYZXVXJZu/n8BFuFmJ2IWAJamlrqOxQ3pv7V8WGNKJKkTKpq3J2guO14cZWkeu04FQ5URhOO0Mjjkfa8i00DkM6aM4oDmuEdb26uQK1L6wm2PrHUY28by28WEWqmi4YkGqr88ApyZQ56+8TfZ6cCIihWPdpSOZ0V0Bw553vd6iakVJLuuojTVxJPlZWmwe8TevVfEc9kGikSMf7PmVoaYPX/z0VcmHjTgoY6D3hcniYJBNlBlXG2xBGaJyQ1DnbDoZSg/d4uuFiU6UXMIA/ftx+sBPPWBfQcGe3p3u46XNYMFNKOM0QZEBhCzbGSyIvOtvTbzFJQ510rqzDlWfvOQZm1q86IuiuKUSsJpf1Z8+/RDlDQ5K2HqSjymb33wDTRvbqu4tXt7a/3v5pWK1YxZt+7ko1WllfjWLfD+8O/4mCh3JDO3agBHdr4LjesGdQ5DezPNDpbLT5juwxzxebQ5ufbENDY+dRy8FaDwDEuen42spQ/8P6EZ/BCLc0fZ3neOrwh47v2PfLe/1rfHkR511ClltmkeaFIHNfCJzT2oPfA+rDr4NzoCnbE8Fu+Mf37PLVjYtD4HKndnBc+6K8pase3wcYw+O54eMuYvl8Y+SNlZrSbjQQeB+yjbsyFJNRNKt+589C39QwN7nB6yksyWnDzbVwgamq6CaBWpdDG7PptdUpOCwFJvJWZiGF9h0Z2cFwZpG3Xp3Z6cqvWRGsy+uvDq0Fbz4hQweYZSzfMe7Wa+KPa+sNGgSJYlv9K/hjbFpFVmOiK7ziWOzdUJ2xhR4uk0BQTMEZFPKEZOTeL8yHB8TJ3ojO8iS5hCL8s2A8cuaP0oprU5tpFzu0MbgGi5RlTv7QKcgBL5aFr8mFSy9ObXW2DHaes5taDX4dRwLhVv+eM/8PK5WcyvGe6yG8uFExPeDGqXvHfjxBw2nLqY0tmOuUwnRiY4KoLpPXg71e1mS7l8FflHaxh2UxH/GHHN5DL4wb+SLl+/MwlKLKuIPdv+fgKR5V5W5Eqm4WvvqaDGHcUMtVwlTjFnZjwucuvg0Cxjck50ogLA3ejSDxOEoriZrvC4yXmj9JuMjRid/jCVOHWH5BRsJrrblIUGYYAm67ftXf0jgjwFNdPLWlVzgHMeFllAWQNkSKfHEskzSbXt48bS+ZXPeNdOU9WtoG3me5ECMlQWdn6vy8m01D8myHKniNLMCZNjz6IJmwlQ3e/DoEMnQ8tNOk064fVUNtWq1R4/NPRi3fpYN54ujHlWJaI9LM+seYgkaVHnWjw2nvoxjsWUbqWcTgFHgnbb7CxFufVJFCzIg82yEz+K2ID0G9JSu/lao9W+c+Mz+46e3fkwHbRGv61w9x1y05GoYuld5JIYkQnbKF6crRDOLNpnyta0cGjO+8vNcX62c8Y2YSKCfi6N2s37RRCqHXwQG5LuEZQdGZE2YiKID9REWxFYps7hsZl244mxw48lP5c+u327e0P/e+6gJW6MzOJI49jnFNIRdA5Gvsiu9zKHQjpdFUpFVp76Vk4XpUvtaOIX5i9p1JtIxiimLA7D+9G633zhJEoppZRSSimllFJKKaWUUkq5jPwPePZkmG2Ch0MAAAAASUVORK5CYII="
                                                                            alt="customer image"
                                                                            width={26}
                                                                            height={21}
                                                                        />
                                                                        <span id="customer-balance" className="js-customer-balance">
                                                                            <span className="-amount"><NumericFormat value={balance} displayType={'text'} thousandSeparator={true} /> </span>
                                                                        </span>
                                                                    </div>
                                                                    <button
                                                                        type="button"
                                                                        onClick={(e) => {
                                                                            this.recheccredit(e)
                                                                        }}
                                                                        id="btn-customer-balance-reload"
                                                                        className="-btn-balance"
                                                                        data-loading="_onReloadBalance_"
                                                                        data-done="_onReloadBalanceDone_"
                                                                    >
                                                                        <i className="fas fa-sync-alt f-9" />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="-overlay" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    : ""}
                            </div>
                        </div>
                    </div>
                </nav>

                <div id="main__content">
                    <div className="x-main-container">
                        <div className="x-main-content">
                            <div className="-contact-wrapper row m-0 ">
                                <div className="x-main-side-bar" >
                                    <div class="x-menu-provider js-tab-menu-provider -desktop-view MenuLeft">
                                        <nav className="nav-menu animated animatedFadeInUp in-left" id="navbarCategory">
                                            <ul className="x-menu-provider nav nav-pills js-menu-container -nav-menu-container mt-2">
                                                <li className="nav-item">
                                                    <button
                                                        className={"nav-link -casino " + (pathname === "" ? "active" : "")}
                                                        onClick={(e) => {
                                                            this.checkurl(e, "/")
                                                        }}
                                                    >
                                                        <img
                                                            src="https://cdn.javisx.com/image/3742cf82-9809-42a8-8d6c-7d6a708cce2d.png"
                                                            alt="img webคาสิโน บาคาร่า รูเล็ต ซิคโบ ไฮโล"
                                                            className="img-fluid -ic-menu"
                                                            width={55}
                                                            height={55}
                                                        />
                                                        <div className="-text-provider-wrapper pl-1-mobile">
                                                            <div className="-text-nav-menu -title -title-active">
                                                                <span>ยอดนิยม</span>
                                                            </div>
                                                        </div>
                                                    </button>
                                                </li>
                                                <li className="nav-item">
                                                    <button
                                                        className={"nav-link -casino " + (pathname === "casino" ? "active" : "")}
                                                        onClick={(e) => {
                                                            this.checkurl(e, "/casino")
                                                        }}
                                                    >
                                                        <img
                                                            src="https://cdn.javisx.com/image/8f441725-8089-4ac7-b2c6-f35617eb77ce.png"
                                                            alt="img webคาสิโน บาคาร่า รูเล็ต ซิคโบ ไฮโล"
                                                            className="img-fluid -ic-menu"
                                                            width={55}
                                                            height={55}
                                                        />
                                                        <div className="-text-provider-wrapper pl-1-mobile">
                                                            <div className="-text-nav-menu -title">
                                                                <span>คาสิโน</span>
                                                            </div>
                                                        </div>
                                                    </button>
                                                </li>
                                                <li className="nav-item">
                                                    <button
                                                        className={"nav-link -casino " + (pathname === "slot" ? "active" : "")}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            this.checkurl(e, "/slot")
                                                        }}
                                                    >
                                                        <img
                                                            src="https://cdn.javisx.com/image/02085a6e-c2d8-4de2-b418-17329ca00dd8.png"
                                                            alt="img webคาสิโน บาคาร่า รูเล็ต ซิคโบ ไฮโล"
                                                            className="img-fluid -ic-menu"
                                                            width={55}
                                                            height={55}
                                                        />
                                                        <div className="-text-provider-wrapper pl-1-mobile">
                                                            <div className="-text-nav-menu -title">
                                                                <span>สล็อต</span>
                                                            </div>
                                                        </div>
                                                    </button>
                                                </li>
                                                <li className="nav-item">
                                                    <button
                                                        className={"nav-link -casino " + (pathname === "sport" ? "active" : "")}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            this.checkurl(e, "/sport")
                                                        }}
                                                    >
                                                        <img
                                                            src="https://cdn.javisx.com/image/1896fc54-386b-4589-910b-55ff907120e0.png"
                                                            alt="img webคาสิโน บาคาร่า รูเล็ต ซิคโบ ไฮโล"
                                                            className="img-fluid -ic-menu"
                                                            width={55}
                                                            height={55}
                                                        />
                                                        <div className="-text-provider-wrapper pl-1-mobile">
                                                            <div className="-text-nav-menu -title">
                                                                <span>กีฬา</span>
                                                            </div>
                                                        </div>
                                                    </button>
                                                </li>
                                                <li className="nav-item">
                                                    <button
                                                        className={"nav-link -casino " + (pathname === "fishing" ? "active" : "")}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            this.checkurl(e, "/fishing")
                                                        }}
                                                    >
                                                        <img
                                                            src="https://cdn.javisx.com/image/2c08ed7c-b40c-4262-b61e-b74d8b965fe6.png"
                                                            alt="img webคาสิโน บาคาร่า รูเล็ต ซิคโบ ไฮโล"
                                                            className="img-fluid -ic-menu"
                                                            width={55}
                                                            height={55}
                                                        />
                                                        <div className="-text-provider-wrapper pl-1-mobile">
                                                            <div className="-text-nav-menu -title">
                                                                <span>ยิงปลา</span>
                                                            </div>
                                                        </div>
                                                    </button>
                                                </li>
                                                {/* <li className="nav-item">
                                                    <button
                                                        className={"nav-link -casino " + (pathname === "trading" ? "active" : "")}
                                                    >
                                                        <img
                                                            src="https://imagedelivery.net/OxMo058wRPZzbWHctmHqkA/5b83a31b-93a0-4d6f-71c7-5b2b73bacb00/public"
                                                            alt="img webคาสิโน บาคาร่า รูเล็ต ซิคโบ ไฮโล"
                                                            className="img-fluid -ic-menu"
                                                            width={55}
                                                            height={55}
                                                        />
                                                        <div className="-text-provider-wrapper pl-1-mobile">
                                                            <div className="-text-nav-menu -title">
                                                                <span>เทรดดิ้ง</span>
                                                            </div>
                                                        </div>
                                                    </button>
                                                </li> */}
                                                <li className="nav-item">
                                                    <button
                                                        className={"nav-link -casino " + (pathname === "lotto" ? "active" : "")}
                                                    >
                                                        <img
                                                            src="https://cdn.javisx.com/image/7a5f03fc-02ab-4cdd-9792-aa1de7567e45.png"
                                                            alt="img webคาสิโน บาคาร่า รูเล็ต ซิคโบ ไฮโล"
                                                            className="img-fluid -ic-menu"
                                                            width={55}
                                                            height={55}
                                                        />
                                                        <div className="-text-provider-wrapper pl-1-mobile">
                                                            <div className="-text-nav-menu -title">
                                                                <span>หวย</span>
                                                            </div>
                                                        </div>
                                                    </button>
                                                </li>
                                            </ul>
                                            <div className="-contact-wrapper m-4">
                                                <div className="x-contact-us -text">
                                                    <a role="button" href={this.state.linelink} className="-line-wrapper" rel="noopener noreferrer">
                                                        <img
                                                            role="button"
                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a5205298-bde9-4817-4f93-32dc3822b700/public"
                                                            className="-line-img"
                                                            width={160}
                                                            height={51}
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                        </nav>
                                    </div>
                                </div>
                                <div className="x-main-content" style={{ display: this.state.tabselect === 10 || this.state.tabselect === 15 || this.state.tabselect === 14 || this.state.tabselect === 13 || this.state.tabselect === 12 || this.state.tabselect === 0 || this.state.tabselect === 11 ? "" : "none" }}>
                                    <div className="-contact-wrapper row m-0 " >
                                        <div className="d-lg-none" style={{ display: this.state.tabselect === 10 || this.state.tabselect === 15 || this.state.tabselect === 14 || this.state.tabselect === 13 || this.state.tabselect === 12 || this.state.tabselect === 0 || this.state.tabselect === 11 ? "" : "none" }} >
                                            <div>
                                                <br />
                                                <br />
                                                <br />
                                            </div>
                                            <div>
                                                <TextSlider />
                                            </div>

                                            <div style={{ marginTop: "7px" }}  >
                                                <Banner />
                                            </div>

                                        </div>
                                        <div className="-games-provider-wrapper pl-0 pr-0 mx-auto -menu-index-page-bg col-3 col-sm-3 col-md-2 col-lg-2 col-xl-2 pl-0 pr-0 " >
                                            <div className="-menu-index-page animated animatedFadeInUp in-left scroll-y-menu-left" >
                                                <div data-menu-sticky="js-sticky-widget" className="js-sticky-widget">
                                                    <div className="x-menu-provider js-tab-menu-provider">
                                                        <nav className="nav-menu" id="navbarCategory">
                                                            <ul className="nav nav-pills js-menu-container -nav-menu-container mt-2">
                                                                <li className="nav-item nav-img-bg w-100">
                                                                    <button className={"active-color-menu  nav-link -casino w-100 " + (pathname === "" ? "active" : "")}
                                                                        onClick={(e) => {
                                                                            this.checkurl(e, "/")
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src="https://cdn.javisx.com/image/3742cf82-9809-42a8-8d6c-7d6a708cce2d.png"
                                                                            alt="https://cdn.javisx.com/image/3742cf82-9809-42a8-8d6c-7d6a708cce2d.png"
                                                                            className="menu-icon-left-active img-fluid -ic-menu"
                                                                        />
                                                                        <div className="-text-provider-wrapper">
                                                                            <div className="-text-nav-menu -title">
                                                                                <span>ยอดนิยม</span>
                                                                            </div>
                                                                            <div className="-text-nav-menu -title-trans">
                                                                                <span>ยอดนิยม</span>
                                                                            </div>
                                                                            <div className="-text-nav-menu -title-mobile">
                                                                                <span>ยอดนิยม</span>
                                                                            </div>
                                                                        </div>
                                                                        {/**/}
                                                                    </button>
                                                                </li>
                                                                <li className="nav-item nav-img-bg w-100">
                                                                    <button className={"nav-link -casino w-100 " + (pathname === "casino" ? "active" : "")}
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            this.checkurl(e, "/casino")
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src="https://cdn.javisx.com/image/8f441725-8089-4ac7-b2c6-f35617eb77ce.png"
                                                                            alt="https://cdn.javisx.com/image/8f441725-8089-4ac7-b2c6-f35617eb77ce.png"
                                                                            className="menu-icon-left img-fluid -ic-menu"
                                                                        />
                                                                        <div className="-text-provider-wrapper">
                                                                            <div className="-text-nav-menu -title">
                                                                                <span>คาสิโน</span>
                                                                            </div>
                                                                            <div className="-text-nav-menu -title-trans">
                                                                                <span>คาสิโน</span>
                                                                            </div>
                                                                            <div className="-text-nav-menu -title-mobile">
                                                                                <span>คาสิโน</span>
                                                                            </div>
                                                                        </div>
                                                                        {/**/}
                                                                    </button>
                                                                </li>
                                                                <li className="nav-item nav-img-bg w-100">
                                                                    <button className={"nav-link -casino w-100 " + (pathname === "slot" ? "active" : "")} onClick={(e) => {
                                                                        e.preventDefault();
                                                                        this.checkurl(e, "/slot")
                                                                    }}
                                                                    >
                                                                        <img
                                                                            src="https://cdn.javisx.com/image/3742cf82-9809-42a8-8d6c-7d6a708cce2d.png"
                                                                            alt="https://cdn.javisx.com/image/3742cf82-9809-42a8-8d6c-7d6a708cce2d.png"
                                                                            className="menu-icon-left img-fluid -ic-menu"
                                                                        />
                                                                        <div className="-text-provider-wrapper">
                                                                            <div className="-text-nav-menu -title">
                                                                                <span>สล็อต</span>
                                                                            </div>
                                                                            <div className="-text-nav-menu -title-trans">
                                                                                <span>สล็อต</span>
                                                                            </div>
                                                                            <div className="-text-nav-menu -title-mobile">
                                                                                <span>สล็อต</span>
                                                                            </div>
                                                                        </div>
                                                                    </button>
                                                                </li>
                                                                <li className="nav-item nav-img-bg w-100">
                                                                    <button className={"nav-link -casino w-100 " + (pathname === "sport" ? "active" : "")} onClick={(e) => {
                                                                        e.preventDefault();
                                                                        this.checkurl(e, "/sport")
                                                                    }}
                                                                    > <img
                                                                            src="https://cdn.javisx.com/image/1896fc54-386b-4589-910b-55ff907120e0.png"
                                                                            alt="https://cdn.javisx.com/image/1896fc54-386b-4589-910b-55ff907120e0.png"
                                                                            className="menu-icon-left img-fluid -ic-menu"
                                                                        />
                                                                        <div className="-text-provider-wrapper">
                                                                            <div className="-text-nav-menu -title">
                                                                                <span>กีฬา</span>
                                                                            </div>
                                                                            <div className="-text-nav-menu -title-trans">
                                                                                <span>กีฬา</span>
                                                                            </div>
                                                                            <div className="-text-nav-menu -title-mobile">
                                                                                <span>กีฬา</span>
                                                                            </div>
                                                                        </div>
                                                                        {/**/}
                                                                    </button>
                                                                </li>
                                                                <li className="nav-item nav-img-bg w-100">
                                                                    <button className={"nav-link -casino w-100 " + (pathname === "fishing" ? "active" : "")} onClick={(e) => {
                                                                        e.preventDefault();
                                                                        this.checkurl(e, "/fishing")
                                                                    }}
                                                                    >
                                                                        <img
                                                                            src="https://cdn.javisx.com/image/2c08ed7c-b40c-4262-b61e-b74d8b965fe6.png"
                                                                            alt="https://cdn.javisx.com/image/2c08ed7c-b40c-4262-b61e-b74d8b965fe6.png"
                                                                            className="menu-icon-left img-fluid -ic-menu"
                                                                        />
                                                                        <div className="-text-provider-wrapper">
                                                                            <div className="-text-nav-menu -title">
                                                                                <span>ยิงปลา</span>
                                                                            </div>
                                                                            <div className="-text-nav-menu -title-trans">
                                                                                <span>ยิงปลา</span>
                                                                            </div>
                                                                            <div className="-text-nav-menu -title-mobile">
                                                                                <span>ยิงปลา</span>
                                                                            </div>
                                                                        </div>
                                                                        {/**/}
                                                                    </button>
                                                                </li>

                                                                <li className="nav-item nav-img-bg w-100">
                                                                    <button className={"nav-link -casino w-100 " + (pathname === "lotto" ? "active" : "")}
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src="https://cdn.javisx.com/image/7a5f03fc-02ab-4cdd-9792-aa1de7567e45.png"
                                                                            alt="https://cdn.javisx.com/image/7a5f03fc-02ab-4cdd-9792-aa1de7567e45.png"
                                                                            className="menu-icon-left img-fluid -ic-menu"
                                                                        />
                                                                        <div className="-text-provider-wrapper">
                                                                            <div className="-text-nav-menu -title">
                                                                                <span>หวย</span>
                                                                            </div>
                                                                            <div className="-text-nav-menu -title-trans">
                                                                                <span>หวย</span>
                                                                            </div>
                                                                            <div className="-text-nav-menu -title-mobile">
                                                                                <span>หวย</span>
                                                                            </div>
                                                                        </div>
                                                                        {/**/}
                                                                    </button>
                                                                </li>
                                                            </ul>
                                                        </nav>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="-games-index-page scroll-y-menu-left-nav col-9 col-sm-9 col-md-10 col-lg-12 col-xl-12 pl-0 pr-0">
                                            <div className="mb-2 text-white-v1">
                                                <div style={{ display: this.state.tabselect === 10 || this.state.tabselect === 15 || this.state.tabselect === 14 || this.state.tabselect === 13 || this.state.tabselect === 12 || this.state.tabselect === 0 || this.state.tabselect === 11 ? "" : "none" }}>
                                                    <div className="d-none d-lg-block" >
                                                        <Mainindex />
                                                    </div>
                                                </div>
                                                <div className="animated animatedFadeInUp fadeInUp">
                                                    <div className="d-flex justify-content-center row align-items-center m-0 bg-navbar-event">
                                                        <div className="col-12 col-md-8 col-lg-6 pt-2 text-center text-white-v1 in-left p-0">
                                                            <div className="d-flex justify-content-between scroll-navbar-menu">
                                                                <div>
                                                                    <div role="button" className="d-lg-none">
                                                                        <img
                                                                            role="button"
                                                                            href="/event"
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/78e85f6d-eedc-495d-1a14-ddb663054200/public"
                                                                            className="w-icon-navbar"
                                                                            alt=""
                                                                        />
                                                                        <div className="p-1 text-navbar-menu">ภารกิจ</div>
                                                                    </div>
                                                                    <div role="button" className="d-none d-lg-block">
                                                                        <img
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/78e85f6d-eedc-495d-1a14-ddb663054200/public"
                                                                            alt=""
                                                                            href="/event"
                                                                            role="button"
                                                                            className="w-icon-navbar p-1"
                                                                        />
                                                                        <small className="p-1 text-navbar-menu">ภารกิจ</small>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <div role="button" className="d-lg-none">
                                                                        <img
                                                                            role="button"
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/108a6343-39d2-4078-fef9-97059fe4dc00/public"
                                                                            className="w-icon-navbar"
                                                                            alt=""
                                                                        />
                                                                        <div className="p-1 text-navbar-menu">เปิดไพ่</div>
                                                                    </div>
                                                                    <div role="button" className="d-none d-lg-block">
                                                                        <img
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/108a6343-39d2-4078-fef9-97059fe4dc00/public"
                                                                            alt=""
                                                                            role="button"
                                                                            className="w-icon-navbar p-1"
                                                                        />
                                                                        <small className="p-1 text-navbar-menu">เปิดไพ่</small>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <div role="button" className="d-lg-none">
                                                                        <img
                                                                            role="button"
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/0cb78f94-6901-4b9c-1b54-6b5a19daf200/public"
                                                                            className="w-icon-navbar"
                                                                            alt=""
                                                                        />
                                                                        <div className="p-1 text-navbar-menu">รางวัล</div>
                                                                    </div>
                                                                    <div role="button" className="d-none d-lg-block">
                                                                        <img
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/0cb78f94-6901-4b9c-1b54-6b5a19daf200/public"
                                                                            alt=""
                                                                            role="button"
                                                                            className="w-icon-navbar p-1"
                                                                        />
                                                                        <small className="p-1 text-navbar-menu">รางวัล</small>
                                                                    </div>
                                                                </div>
                                                                <div  href="https://www.24-hd.com">
                                                                    <a role="button"   href="https://www.24-hd.com" className="d-lg-none">
                                                                        <img
                                                                            href="https://www.24-hd.com"
                                                                            role="button"
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/0e14db76-20a6-475b-6817-fc03e2771e00/public"
                                                                            className="w-icon-navbar"
                                                                            alt=""
                                                                        />
                                                                        <div className="p-1 text-navbar-menu">ดูหนัง</div>
                                                                    </a>
                                                                    <a role="button"   href="https://www.24-hd.com" className="d-none d-lg-block">
                                                                        <img
                                                                            href="https://www.24-hd.com"
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/0e14db76-20a6-475b-6817-fc03e2771e00/public"
                                                                            alt=""
                                                                            role="button"
                                                                            className="w-icon-navbar p-1"
                                                                        />
                                                                        <small className="p-1 text-navbar-menu">ดูหนัง</small>
                                                                    </a>
                                                                </div>
                                                                <div   href="https://dooball66x.com">
                                                                    <a role="button"      href="https://dooball66x.com" className="d-lg-none">
                                                                        <img
                                                                            role="button"
                                                                            href="https://dooball66x.com"
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8845b4ec-2be0-4f00-78bd-63a49f439000/public"
                                                                            className="w-icon-navbar"
                                                                            alt=""
                                                                        />
                                                                        <div className="p-1 text-navbar-menu">ดูบอล</div>
                                                                    </a>
                                                                    <a role="button"      href="https://dooball66x.com" className="d-none d-lg-block">
                                                                        <img
                                                                            href="https://dooball66x.com"
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8845b4ec-2be0-4f00-78bd-63a49f439000/public"
                                                                            alt=""
                                                                            role="button"
                                                                            className="w-icon-navbar p-1"
                                                                        />
                                                                        <small className="p-1 text-navbar-menu">ดูบอล</small>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="container p-0">
                                                    <div className="js-replace-heading-sub-title-seo-container text-center animated animatedFadeInUp fadeInUp mt-1">
                                                        {/**/}
                                                    </div>
                                                </div>
                                                <div className="padding-router-view">
                                                    <div>
                                                        <main className="container p-0">
                                                            <div style={{ display: this.state.tabselect == 0 ? "" : "none" }}>
                                                                <div className="m-bg-title text-white-v1">

                                                                    <div className="clearfix bg-index-button example animated animatedFadeInUp fadeInUp">
                                                                        <div className="m-0 d-flex justify-content-between pt-1 pb-1 align-items-center">
                                                                            <div className="d-flex justify-content-start w-100 align-items-center">
                                                                                <div>
                                                                                    <img
                                                                                        className="img-title-games-hot"
                                                                                        src="https://cdn.javisx.com/image/8f441725-8089-4ac7-b2c6-f35617eb77ce.png"
                                                                                        alt=""
                                                                                    />
                                                                                </div>
                                                                                <div className="p-1 title-pannel-game color4 w-100">
                                                                                    <span className="text-title-popular">
                                                                                        คาสิโนออนไลน์ ยอดนิยม
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="text-white-v1">
                                                                    <div className="pt-1 pb-1 text-white-v1">
                                                                        <div className="x-category-provider js-game-scroll-container js-game-container">
                                                                            <div className="-games-list-container container">
                                                                                <nav className="nav-menu" id="navbarProvider">
                                                                                    <ul className="nav nav-pills row animated animatedFadeInUp fadeInUp">
                                                                                        {categorylist.map((listitem, i) => (
                                                                                            <li className="col-6 col-lg-2 col-md-3 nav-item -random-container -game-casino-macro-container p-1 pb-0 mb-2" typetext="" >
                                                                                                <a
                                                                                                    onClick={(e) => {
                                                                                                        this.checkurl(e, "/listgameall/casino/" + listitem.partner)
                                                                                                    }}
                                                                                                >
                                                                                                    <div
                                                                                                        className="x-game-list-item-macro js-game-list-toggle -big -cannot-entry -untestable example bg-card-item"
                                                                                                        data-status="-cannot-entry -untestable bg-card-item"
                                                                                                    >
                                                                                                        <div className="-inner-wrapper card-width-banner-games">
                                                                                                            <div />
                                                                                                            <picture>
                                                                                                                <img
                                                                                                                    role="button"
                                                                                                                    className="w-100 hover-slot hoverTextCss"
                                                                                                                    lazy="loaded"
                                                                                                                    src={listitem.image}
                                                                                                                />
                                                                                                            </picture>
                                                                                                            <div className="-overlay d-none d-lg-block">
                                                                                                                <div className="-overlay-inner">
                                                                                                                    <div className="-wrapper-container">
                                                                                                                        <a role="button"
                                                                                                                            // onClick={(e) => {
                                                                                                                            //     this.checkurl(e, "/listgameall/casino/" + listitem.partner)
                                                                                                                            // }}

                                                                                                                            className="-btn v-login js-account-approve-aware"  >
                                                                                                                            <svg
                                                                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                                                                width={20}
                                                                                                                                height={20}
                                                                                                                                fill="currentColor"
                                                                                                                                className="bi bi-play-circle-fill m-2"
                                                                                                                                viewBox="0 0 16 16"
                                                                                                                            >
                                                                                                                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z" />
                                                                                                                            </svg>
                                                                                                                            <span className="-text-btn">เข้าเล่น</span>
                                                                                                                        </a>

                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div>
                                                                                                            <div>{/**/}</div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </a>
                                                                                            </li>
                                                                                        ))}
                                                                                    </ul>
                                                                                </nav>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="m-bg-title text-white-v1">
                                                                    <div className="clearfix bg-index-button example animated animatedFadeInUp fadeInUp">
                                                                        <div className="m-0 d-flex justify-content-between pt-1 pb-1 align-items-center">
                                                                            <div className="d-flex justify-content-start w-100 align-items-center">
                                                                                <div>
                                                                                    <img
                                                                                        className="img-title-games-hot"
                                                                                        src="https://cdn.javisx.com/image/3742cf82-9809-42a8-8d6c-7d6a708cce2d.png"
                                                                                        alt=""
                                                                                    />
                                                                                </div>
                                                                                <div className="p-1 title-pannel-game color4 w-100">
                                                                                    <span className="text-title-popular">สล็อตยอดนิยม</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="text-white-v1 animated animatedFadeInUp fadeInUp">
                                                                    <div className="pt-1 pb-1 text-white-v1">
                                                                        <div className="x-category-provider js-game-scroll-container js-game-container">
                                                                            <div className="-games-list-container container">
                                                                                <nav className="nav-menu" id="navbarProvider">
                                                                                    <ul className="nav nav-pills row animated animatedFadeInUp fadeInUp">
                                                                                        {this.state.slotlist.map((listitem, i) => (
                                                                                            <li className="col-6 col-lg-2 col-md-3 nav-item -random-container -game-casino-macro-container p-1 pb-0 mb-2" typetext=""
                                                                                            >
                                                                                                <a
                                                                                                    onClick={(e) => {
                                                                                                        this.checkurl(e, "/listgameall/slot/" + listitem.partner)
                                                                                                    }}
                                                                                                >
                                                                                                    <div
                                                                                                        className="x-game-list-item-macro js-game-list-toggle -big -cannot-entry -untestable example bg-card-item"
                                                                                                        data-status="-cannot-entry -untestable bg-card-item"
                                                                                                    >
                                                                                                        <div className="-inner-wrapper card-width-banner-games">
                                                                                                            <div />
                                                                                                            <picture>
                                                                                                                <img
                                                                                                                    role="button"
                                                                                                                    className="w-100 hover-slot hoverTextCss"
                                                                                                                    lazy="loading"
                                                                                                                    src={listitem.image}
                                                                                                                />
                                                                                                            </picture>
                                                                                                            <div className="-overlay d-none d-lg-block">
                                                                                                                <div className="-overlay-inner">
                                                                                                                    <div className="-wrapper-container">
                                                                                                                        <a
                                                                                                                            role="button"
                                                                                                                            onClick={(e) => {
                                                                                                                                this.checkurl(e, "/listgameall/slot/" + listitem.partner)
                                                                                                                            }}

                                                                                                                            className="-btn v-login js-account-approve-aware" >
                                                                                                                            <svg
                                                                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                                                                width={20}
                                                                                                                                height={20}
                                                                                                                                fill="currentColor"
                                                                                                                                className="bi bi-play-circle-fill m-2"
                                                                                                                                viewBox="0 0 16 16"
                                                                                                                            >
                                                                                                                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z" />
                                                                                                                            </svg>
                                                                                                                            <span className="-text-btn">
                                                                                                                                เข้าสู่ระบบ
                                                                                                                            </span>
                                                                                                                        </a>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div>
                                                                                                            <div>{/**/}</div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </a>
                                                                                            </li>
                                                                                        ))}

                                                                                    </ul>
                                                                                </nav>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div style={{ display: this.state.tabselect == 10 ? "" : "none" }}>
                                                                <div className="padding-router-view">
                                                                    <div>
                                                                        <main className="container p-0">
                                                                            <div className="pt-1 pb-3 text-white-v1 w-scroll-height-casino">
                                                                                <div className="x-category-provider js-game-scroll-container js-game-container animated animatedFadeInUp fadeInUp">
                                                                                    <div className="-games-list-container container">
                                                                                        <nav className="nav-menu" id="navbarProvider">
                                                                                            <ul className="nav nav-pills row animated animatedFadeInUp fadeInUp">
                                                                                                {/**/}
                                                                                                {categorylist.map((listitem, i) => (
                                                                                                    <li className="col-6 col-lg-2 col-md-3 nav-item -random-container -game-casino-macro-container p-1 pb-0 mb-2">
                                                                                                        <a
                                                                                                            onClick={(e) => {
                                                                                                                this.checkurl(e, "/listgameall/slot/" + listitem.partner)
                                                                                                            }}
                                                                                                        >
                                                                                                            <div
                                                                                                                className="x-game-list-item-macro js-game-list-toggle -big -cannot-entry -untestable example bg-card-item"
                                                                                                                data-status="-cannot-entry -untestable bg-card-item"
                                                                                                            >
                                                                                                                <div className="-inner-wrapper card-width-banner-games">
                                                                                                                    <div>
                                                                                                                    </div>
                                                                                                                    <picture>
                                                                                                                        <img
                                                                                                                            role="button"
                                                                                                                            className="w-100 hover-slot hoverTextCss"
                                                                                                                            lazy="loaded"
                                                                                                                            src={listitem.image}
                                                                                                                        />
                                                                                                                    </picture>
                                                                                                                    <div className="-overlay d-none d-lg-block">
                                                                                                                        <div className="-overlay-inner">
                                                                                                                            <div className="-wrapper-container">
                                                                                                                                <button
                                                                                                                                    role="button"
                                                                                                                                    className="-btn v-login js-account-approve-aware"

                                                                                                                                // onClick={(e) => {
                                                                                                                                //     this.checkurl(e, "/listgameall/slot/" + listitem.partner)
                                                                                                                                // }}
                                                                                                                                >
                                                                                                                                    <svg
                                                                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                                                                        width={20}
                                                                                                                                        height={20}
                                                                                                                                        fill="currentColor"
                                                                                                                                        className="bi bi-play-circle-fill m-2"
                                                                                                                                        viewBox="0 0 16 16"
                                                                                                                                    >
                                                                                                                                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z" />
                                                                                                                                    </svg>
                                                                                                                                    <span className="-text-btn">เข้าเล่น</span>
                                                                                                                                </button>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <div>
                                                                                                                    <div>{/**/}</div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </a>
                                                                                                    </li>
                                                                                                ))}
                                                                                            </ul>
                                                                                        </nav>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </main>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div style={{ display: this.state.tabselect == 12 ? "" : "none" }}>
                                                                <div className="padding-router-view">
                                                                    <div>
                                                                        <main className="container p-0">
                                                                            <div className="pt-1 pb-3 text-white-v1 w-scroll-height-casino">
                                                                                <div className="x-category-provider js-game-scroll-container js-game-container animated animatedFadeInUp fadeInUp">
                                                                                    <div className="-games-list-container container">
                                                                                        <nav className="nav-menu" id="navbarProvider">
                                                                                            <ul className="nav nav-pills row animated animatedFadeInUp fadeInUp">
                                                                                                {/**/}
                                                                                                {fishinglist.map((listitem, i) => (
                                                                                                    <li className="col-6 col-lg-2 col-md-3 nav-item -random-container -game-casino-macro-container p-1 pb-0 mb-2">
                                                                                                        <a onClick={(e) => {
                                                                                                            this.checkurl(e, "/listgameall/slot/" + listitem.partner)
                                                                                                        }}>
                                                                                                            <div
                                                                                                                className="x-game-list-item-macro js-game-list-toggle -big -cannot-entry -untestable example bg-card-item"
                                                                                                                data-status="-cannot-entry -untestable bg-card-item"
                                                                                                            >
                                                                                                                <div className="-inner-wrapper card-width-banner-games">
                                                                                                                    <div>
                                                                                                                    </div>
                                                                                                                    <picture>
                                                                                                                        <img
                                                                                                                            role="button"
                                                                                                                            className="w-100 hover-slot hoverTextCss"
                                                                                                                            lazy="loaded"
                                                                                                                            src={listitem.image}
                                                                                                                        />
                                                                                                                    </picture>
                                                                                                                    <div className="-overlay d-none d-lg-block">
                                                                                                                        <div className="-overlay-inner">
                                                                                                                            <div className="-wrapper-container">
                                                                                                                                <button
                                                                                                                                    role="button"
                                                                                                                                    className="-btn v-login js-account-approve-aware"
                                                                                                                                    href={"/listgameall/casino/" + listitem.partner}
                                                                                                                                >
                                                                                                                                    <svg
                                                                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                                                                        width={20}
                                                                                                                                        height={20}
                                                                                                                                        fill="currentColor"
                                                                                                                                        className="bi bi-play-circle-fill m-2"
                                                                                                                                        viewBox="0 0 16 16"
                                                                                                                                    >
                                                                                                                                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z" />
                                                                                                                                    </svg>
                                                                                                                                    <span className="-text-btn">เข้าเล่น</span>
                                                                                                                                </button>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <div>
                                                                                                                    <div>{/**/}</div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </a>
                                                                                                    </li>
                                                                                                ))}
                                                                                            </ul>
                                                                                        </nav>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </main>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div style={{ display: this.state.tabselect == 13 ? "" : "none" }}>
                                                                <div className="padding-router-view">
                                                                    <div>
                                                                        <main className="container p-0">
                                                                            <div className="pt-1 pb-3 text-white-v1 w-scroll-height-casino">
                                                                                <div className="x-category-provider js-game-scroll-container js-game-container animated animatedFadeInUp fadeInUp">
                                                                                    <div className="-games-list-container container">
                                                                                        <nav className="nav-menu" id="navbarProvider">
                                                                                            <ul className="nav nav-pills row animated animatedFadeInUp fadeInUp">
                                                                                                {/**/}
                                                                                                {slotlist.map((listitem, i) => (
                                                                                                    <li className="col-6 col-lg-2 col-md-3 nav-item -random-container -game-casino-macro-container p-1 pb-0 mb-2">
                                                                                                        <a onClick={(e) => {
                                                                                                            this.checkurl(e, "/listgameall/slot/" + listitem.partner)
                                                                                                        }}>
                                                                                                            <div
                                                                                                                className="x-game-list-item-macro js-game-list-toggle -big -cannot-entry -untestable example bg-card-item"
                                                                                                                data-status="-cannot-entry -untestable bg-card-item"
                                                                                                            >
                                                                                                                <div className="-inner-wrapper card-width-banner-games">
                                                                                                                    <div>
                                                                                                                    </div>
                                                                                                                    <picture>
                                                                                                                        <img
                                                                                                                            role="button"
                                                                                                                            className="w-100 hover-slot hoverTextCss"
                                                                                                                            lazy="loaded"
                                                                                                                            src={listitem.image}
                                                                                                                        />
                                                                                                                    </picture>
                                                                                                                    <div className="-overlay d-none d-lg-block">
                                                                                                                        <div className="-overlay-inner">
                                                                                                                            <div className="-wrapper-container">
                                                                                                                                <button
                                                                                                                                    role="button"
                                                                                                                                    className="-btn v-login js-account-approve-aware"
                                                                                                                                    href={"/listgameall/casino/" + listitem.partner}
                                                                                                                                >
                                                                                                                                    <svg
                                                                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                                                                        width={20}
                                                                                                                                        height={20}
                                                                                                                                        fill="currentColor"
                                                                                                                                        className="bi bi-play-circle-fill m-2"
                                                                                                                                        viewBox="0 0 16 16"
                                                                                                                                    >
                                                                                                                                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z" />
                                                                                                                                    </svg>
                                                                                                                                    <span className="-text-btn">เข้าเล่น</span>
                                                                                                                                </button>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <div>
                                                                                                                    <div>{/**/}</div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </a>
                                                                                                    </li>
                                                                                                ))}
                                                                                            </ul>
                                                                                        </nav>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </main>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div style={{ display: this.state.tabselect == 14 ? "" : "none" }}>
                                                                <div className="padding-router-view">
                                                                    <div>
                                                                        <main className="container p-0">
                                                                            <div className="pt-1 pb-3 text-white-v1 w-scroll-height-casino">
                                                                                <div className="x-category-provider js-game-scroll-container js-game-container animated animatedFadeInUp fadeInUp">
                                                                                    <div className="-games-list-container container">
                                                                                        <nav className="nav-menu" id="navbarProvider">
                                                                                            <ul className="nav nav-pills row animated animatedFadeInUp fadeInUp">
                                                                                                {/**/}
                                                                                                {sportlist.map((listitem, i) => (
                                                                                                    <li className="col-6 col-lg-2 col-md-3 nav-item -random-container -game-casino-macro-container p-1 pb-0 mb-2">
                                                                                                        <a onClick={(e) => {
                                                                                                            this.checkurl(e, "/listgameall/slot/" + listitem.partner)
                                                                                                        }}>
                                                                                                            <div
                                                                                                                className="x-game-list-item-macro js-game-list-toggle -big -cannot-entry -untestable example bg-card-item"
                                                                                                                data-status="-cannot-entry -untestable bg-card-item"
                                                                                                            >
                                                                                                                <div className="-inner-wrapper card-width-banner-games">
                                                                                                                    <div>
                                                                                                                    </div>
                                                                                                                    <picture>
                                                                                                                        <img
                                                                                                                            role="button"
                                                                                                                            className="w-100 hover-slot hoverTextCss"
                                                                                                                            lazy="loaded"
                                                                                                                            src={listitem.image}
                                                                                                                        />
                                                                                                                    </picture>
                                                                                                                    <div className="-overlay d-none d-lg-block">
                                                                                                                        <div className="-overlay-inner">
                                                                                                                            <div className="-wrapper-container">
                                                                                                                                <button
                                                                                                                                    role="button"
                                                                                                                                    className="-btn v-login js-account-approve-aware"
                                                                                                                                    href={"/listgameall/casino/" + listitem.partner}
                                                                                                                                >
                                                                                                                                    <svg
                                                                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                                                                        width={20}
                                                                                                                                        height={20}
                                                                                                                                        fill="currentColor"
                                                                                                                                        className="bi bi-play-circle-fill m-2"
                                                                                                                                        viewBox="0 0 16 16"
                                                                                                                                    >
                                                                                                                                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z" />
                                                                                                                                    </svg>
                                                                                                                                    <span className="-text-btn">เข้าเล่น</span>
                                                                                                                                </button>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <div>
                                                                                                                    <div>{/**/}</div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </a>
                                                                                                    </li>
                                                                                                ))}
                                                                                            </ul>
                                                                                        </nav>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </main>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div style={{ display: this.state.tabselect == 15 ? "" : "none" }}>
                                                                <div className="padding-router-view">
                                                                    <div>
                                                                        <main className="container p-0">
                                                                            <div className="pt-1 pb-3 text-white-v1 w-scroll-height-casino">
                                                                                <div className="x-category-provider js-game-scroll-container js-game-container animated animatedFadeInUp fadeInUp">
                                                                                    <div className="-games-list-container container">
                                                                                        <nav className="nav-menu" id="navbarProvider">
                                                                                            <ul className="nav nav-pills row animated animatedFadeInUp fadeInUp">
                                                                                                {/**/}
                                                                                                {listitallgame.map((listitem, i) => (
                                                                                                    <li className="col-6 col-lg-2 col-md-3 nav-item -random-container -game-casino-macro-container p-1 pb-0 mb-2">
                                                                                                        <a href={() => false}
                                                                                                            onClick={(e) => this.redeem(e, listitem.gameId, listitem.partner)} >
                                                                                                            <div className="x-game-list-item-macro js-game-list-toggle -big -cannot-entry -untestable example bg-card-item"
                                                                                                                data-status="-cannot-entry -untestable bg-card-item"
                                                                                                            >
                                                                                                                <div className="-inner-wrapper card-width-banner-games">
                                                                                                                    <div>
                                                                                                                    </div>
                                                                                                                    <picture>
                                                                                                                        {/* <source id="s1" srcset="image2_broken_link.png" type="image/webp" />
                                                                                                                        <source id="s2" srcset="image2_broken_link.png" type="image/png" /> */}
                                                                                                                        <img
                                                                                                                            role="button"
                                                                                                                            className="w-100 hover-slot hoverTextCss"
                                                                                                                            lazy="loaded"
                                                                                                                            src={this.addDefaultSrc(null, listitem.image)}

                                                                                                                        />
                                                                                                                    </picture>
                                                                                                                    <div className="-overlay d-none d-lg-block">
                                                                                                                        <div className="-overlay-inner">
                                                                                                                            <div className="-wrapper-container">
                                                                                                                                <button
                                                                                                                                    role="button"
                                                                                                                                    className="-btn v-login js-account-approve-aware"
                                                                                                                                    href={"/listgameall/casino/" + listitem.partner}
                                                                                                                                >
                                                                                                                                    <svg
                                                                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                                                                        width={20}
                                                                                                                                        height={20}
                                                                                                                                        fill="currentColor"
                                                                                                                                        className="bi bi-play-circle-fill m-2"
                                                                                                                                        viewBox="0 0 16 16"
                                                                                                                                    >
                                                                                                                                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z" />
                                                                                                                                    </svg>
                                                                                                                                    <span className="-text-btn">เข้าเล่น</span>
                                                                                                                                </button>
                                                                                                                            </div>
                                                                                                                        </div>

                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <div>
                                                                                                                    <div className="progress-web position-progress-data p-2">
                                                                                                                        <div>
                                                                                                                            {this.callpercent(listitem.gameId)}
                                                                                                                            <div>
                                                                                                                                <div className="name-progress-circle-number text-name text-ellipsis d-flex justify-content-between align-items-center">
                                                                                                                                    <div>
                                                                                                                                        <b className="text-ellipsis">
                                                                                                                                            {listitem.description}
                                                                                                                                        </b>
                                                                                                                                    </div>
                                                                                                                                    <div>
                                                                                                                                        <svg
                                                                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                                                                            width={16}
                                                                                                                                            height={16}
                                                                                                                                            fill="currentColor"
                                                                                                                                            className="bi bi-star"
                                                                                                                                            viewBox="0 0 16 16"
                                                                                                                                        >
                                                                                                                                            <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z" />
                                                                                                                                        </svg>
                                                                                                                                    </div>
                                                                                                                                </div>
                                                                                                                                <div className="color-c-g">{listitem.partner}</div>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </a>
                                                                                                    </li>
                                                                                                ))}
                                                                                            </ul>
                                                                                        </nav>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </main>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </main>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="x-main-content" style={{ display: this.state.tabselect !== 10 && this.state.tabselect !== 15 && this.state.tabselect !== 14 && this.state.tabselect !== 13 && this.state.tabselect !== 12 && this.state.tabselect !== 0 && this.state.tabselect !== 11 ? "" : "none" }}>
                                    <div style={{ display: this.state.tabselect == 1 ? "" : "none" }}>
                                        <div>
                                            <br />
                                            <br />
                                            <br />
                                        </div>
                                        <section className="-contact-wrapper row m-0">
                                            <div className="-games-provider-wrapper pl-0 pr-0 mx-auto -menu-index-page-bg col-12">
                                                {/**/}
                                            </div>
                                            <div className="-games-index-page col-12">
                                                <div className="mb-2 text-white-v1">
                                                    <div className="d-none d-lg-block">
                                                        <div>
                                                            <br />
                                                            <br />
                                                            <br />
                                                        </div>
                                                        {/**/}
                                                        {/**/}
                                                        <div>{/**/}</div>
                                                        {/**/}
                                                        {/**/}
                                                    </div>
                                                    {/**/}
                                                    <div className="padding-router-view">
                                                        <div>
                                                            <div className="row m-0 border-shadow-title" >
                                                                <div className="col-12 p-0 col-sm-7 col-md-7 col-lg-7 col-xl-7 mx-auto my-auto text-white-v1">
                                                                    <div className="text-center bg-title-web">
                                                                        <div>
                                                                            <div className="text-title text-white-v1 text-center">
                                                                                <div className="d-flex justify-content-between">
                                                                                    <div className="text-white-v1-deposit">
                                                                                        <a role="button"
                                                                                            href='/'>
                                                                                            <svg
                                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                                width={25}
                                                                                                height={25}
                                                                                                fill="currentColor"
                                                                                                className="bi bi-arrow-left-circle text-color-back"
                                                                                                viewBox="0 0 16 16"
                                                                                            >
                                                                                                <path
                                                                                                    fillRule="evenodd"
                                                                                                    d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"
                                                                                                />
                                                                                            </svg>
                                                                                        </a>
                                                                                    </div>
                                                                                    <div className="text-white-v1-deposit">
                                                                                        <h5>ฝากเงิน</h5>
                                                                                    </div>
                                                                                    <div>{/**/}</div>
                                                                                </div>
                                                                                <hr className="mt-0" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="x-login-index animated animatedFadeInUp fadeInUp">
                                                                        <div>
                                                                            <div className="pt-1 pb-1">
                                                                                <ul className="nav nav-tabs d-flex justify-content-center">
                                                                                    <li className="nav-item text-center w-50 w-margin-padding">
                                                                                        <a
                                                                                            className={this.state.tabselectdeposit == 1 ? "nav-link active" : "nav-link"}
                                                                                            aria-current="page"
                                                                                            href="#"
                                                                                            onClick={(e) => {
                                                                                                this.checktab(e, 1)
                                                                                            }}
                                                                                        >
                                                                                            <img
                                                                                                className="img-bank-title"
                                                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/7c0dc589-eb20-4725-98df-0531730fff00/public"
                                                                                                alt=""
                                                                                            />
                                                                                            <span className="text-font-title-deposit">
                                                                                                ธนาคาร
                                                                                            </span>
                                                                                        </a>
                                                                                    </li>
                                                                                    <li className="nav-item text-center w-50 w-margin-padding">
                                                                                        <a className={this.state.tabselectdeposit == 3 ? "nav-link active" : "nav-link"}
                                                                                            onClick={(e) => {
                                                                                                this.checktab(e, 3)
                                                                                            }}
                                                                                            aria-current="page" href="#">
                                                                                            <img
                                                                                                className="img-bank-title"
                                                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a152f75f-0588-49aa-2836-4d9528f69000/public"
                                                                                                alt=""
                                                                                            />
                                                                                            <span className="text-font-title-deposit">
                                                                                                ทรูมันนี่
                                                                                            </span>
                                                                                        </a>
                                                                                    </li>
                                                                                    {/* <li className="nav-item text-center w-50 w-margin-padding">
                                                                <a className={this.state.tabselect == 2 || this.state.tabselectsec == 1 ? "nav-link active" : "nav-link"}
                                                                    onClick={(e) => {
                                                                        this.checktab(e, 2)
                                                                    }}
                                                                    aria-current="page" href="#">
                                                                    <img
                                                                        className="img-bank-title"
                                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/47a8d8e8-6424-4e84-41f7-f119c3b14e00/public"
                                                                        alt=""
                                                                    />
                                                                    <span className="text-font-title-deposit">
                                                                        สเเกน QR ฝากเงิน
                                                                    </span>
                                                                </a>
                                                            </li> */}
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div className="row m-0 border-shadow-title" style={{ display: this.state.tabselectdeposit == 1 ? "" : "none" }}>
                                                                <div className="col-12 p-0 col-sm-7 col-md-7 col-lg-7 col-xl-7 mx-auto my-auto text-white-v1">
                                                                    <div className="p-1 bg-deposit-button example animated animatedFadeInUp fadeInUp">
                                                                        <div className="mt-3">
                                                                            <div className="x-login-index">
                                                                                <div>
                                                                                    <div>
                                                                                        <div className="mt-3">
                                                                                            <div className="text-white-v1-deposit">
                                                                                                <div>
                                                                                                    <h6 className="mt-1 text-center text-white-v1-deposit">
                                                                                                        <u>บัญชีของคุณ</u>
                                                                                                    </h6>
                                                                                                    <div>
                                                                                                        <div>
                                                                                                            <div className="box-content p-1 p-sm-1">
                                                                                                                <div className="flex justify-between mx-auto">
                                                                                                                    <div className="sub-content w-100 p-3 text-white-v1-deposit">
                                                                                                                        <div className="text-center">
                                                                                                                            <img
                                                                                                                                className="rounded-full w-10 mb-2 flex"
                                                                                                                                src={accnumber !== null ? accnumberx.img_path : ""}
                                                                                                                                style={{ width: 38 }}
                                                                                                                            />{" "}
                                                                                                                            &nbsp; {accnumber !== null ? accnumberx.fullname_th : ""}
                                                                                                                        </div>
                                                                                                                        <div className="text-center">
                                                                                                                            {firstname} &nbsp; | &nbsp;
                                                                                                                            {accnumber !== null ? accnumberx.accno.substring(0, 3) + "-" + accnumberx.accno.substring(3, 9) + "-" + accnumberx.accno.substring(9, 12) : ""}
                                                                                                                        </div>
                                                                                                                        <div className="text-center pt-2">
                                                                                                                            <small className="f-15 text-deposit">
                                                                                                                                (
                                                                                                                                กรุณาโอนเงินด้วยบัญชีที่ระบบแจ้งเท่านั้น
                                                                                                                                )
                                                                                                                            </small>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div>
                                                                                                        {mainacc !== null && mainacc !== undefined ?
                                                                                                            <div className="text-white-v1-deposit text-center">
                                                                                                                <h6 className="mb-2 mt-2 text-center">
                                                                                                                    <u>{"โอนเข้าบัญชี * ขั้นต่ำ " + limits.min + " สูงสุด " + limits.max + " บาท"}</u>
                                                                                                                </h6>
                                                                                                                <div>
                                                                                                                    <div className="flex justify-between mb-1 mx-auto box-content">
                                                                                                                        <div className="sub-content w-100 p-3 px-lg-5">
                                                                                                                            <div className="text-center">
                                                                                                                                <img
                                                                                                                                    className="rounded-full w-10 mb-2 flex"
                                                                                                                                    src={mainacc.img_path}
                                                                                                                                    style={{ width: 38 }}
                                                                                                                                />{" "}
                                                                                                                                &nbsp;{mainacc.fullname_th}
                                                                                                                            </div>
                                                                                                                            <div className="text-center">
                                                                                                                                {mainacc.first_name_en + " " + mainacc.last_name_en} :&nbsp; {
                                                                                                                                    mainacc.accnumber.substring(0, 3) + "-" + mainacc.accnumber.substring(3, 9) + "-" + mainacc.accnumber.substring(9, 12)
                                                                                                                                }
                                                                                                                            </div>
                                                                                                                            <div className="text-center pt-2">
                                                                                                                                <a href={() => false} style={{ cursor: "pointer" }}
                                                                                                                                    onClick={() => this.copyCode(mainacc.accnumber)}
                                                                                                                                //  onClick={() => navigator.clipboard.writeText(mainacc.accnumber)}
                                                                                                                                >
                                                                                                                                    <div
                                                                                                                                        className="btn v-login"
                                                                                                                                        style={{
                                                                                                                                            fontSize: 16,
                                                                                                                                            cursor: "pointer"
                                                                                                                                        }}
                                                                                                                                    >
                                                                                                                                        เลขบัญชี :&nbsp;{" "}
                                                                                                                                        <span id="copy-banktransfer">
                                                                                                                                            {mainacc.accnumber}
                                                                                                                                        </span>{" "}
                                                                                                                                        &nbsp;&nbsp;
                                                                                                                                        <span
                                                                                                                                            className="badge text-bg-white p-1"
                                                                                                                                            style={{
                                                                                                                                                borderRadius: "33.9916px"
                                                                                                                                            }}
                                                                                                                                        >
                                                                                                                                            &nbsp; คัดลอก &nbsp;
                                                                                                                                        </span>
                                                                                                                                    </div>
                                                                                                                                </a>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            : ""}
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="text-white-v1-deposit text-center">
                                                                            <div className="box-content p-0 animated animatedFadeInUp fadeInUp mt-3">
                                                                                <div className="sub-content p-3">
                                                                                    <div className="d-flex justify-content-between">
                                                                                        <div className="text-white-v1-deposit pt-1">
                                                                                            <img
                                                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e8bbd6d-2594-4c50-3863-029c7e9a3500/public"
                                                                                                alt=""
                                                                                                style={{ width: 30 }}
                                                                                            />{" "}
                                                                                            &nbsp; รับโปรโมชั่นอัตโนมัติ
                                                                                        </div>
                                                                                        <div className="text-white-v1-deposit">
                                                                                            <div className="form-check form-switch">
                                                                                                <input
                                                                                                    className="form-check-input"
                                                                                                    type="checkbox"
                                                                                                    role="switch"
                                                                                                    id="flexSwitchCheckDefault"
                                                                                                    style={{ width: "6em", padding: 12 }}
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        {/**/}
                                                                        {/**/}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row m-0 border-shadow-title" style={{ display: this.state.tabselect == 2 ? "" : "none" }}>
                                                                <div className="col-12 p-0 col-sm-7 col-md-7 col-lg-7 col-xl-7 mx-auto my-auto text-white-v1">
                                                                    <div className="p-1 bg-deposit-button example animated animatedFadeInUp fadeInUp">
                                                                        <div className="container p-0 x-margin-top-v3">
                                                                            <div className="row m-0 border-shadow-title">
                                                                                <div className="col-12 p-0 col-sm-12 col-md-12 col-lg-12 col-xl-12 mx-auto my-auto -deposit">
                                                                                    <div className="mt-3 -deposit">
                                                                                        <div className="animated animatedFadeInUp fadeInUp">
                                                                                            <div className="card-promptpay text-center pt-3">
                                                                                                <img
                                                                                                    className="img-logo-promptpay"
                                                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/9c9ef88c-a34b-4aa6-1a42-54ff6cd9a800/public"
                                                                                                    alt=""
                                                                                                />
                                                                                                <span className="">พร้อมเพย์ / ธนาคารเท่านั้น</span>
                                                                                                <div className="pt-3 pb-2 text-left p-detail-promptpay">
                                                                                                    <div className="pt-2 pb-2">
                                                                                                        <small className="p">ระบุจำนวนเงินที่ต้องเติม</small>
                                                                                                    </div>
                                                                                                    <input
                                                                                                        type="text"
                                                                                                        id="depositamount"
                                                                                                        onChange={this.onChangexdep}
                                                                                                        value={this.state.depositamount}
                                                                                                        placeholder="กรอกจำนวนเงิน"
                                                                                                        maxLength={4}
                                                                                                        minLength={4}
                                                                                                        name="number"
                                                                                                        className="form-control promptpay-border-radius"
                                                                                                    />
                                                                                                    <div className="mb-1 mt-2">
                                                                                                        <label htmlFor="price" className="mt-1 mb-1 text-left">
                                                                                                            เลือกจำนวน
                                                                                                        </label>
                                                                                                        <div className="mb-4 row m-0">
                                                                                                            <div className="col-4 col-md-4 px-1">
                                                                                                                <div className="card-amount mt-2 text-white-v1"
                                                                                                                    onClick={(e) => this.handleClickdeposit(e, 100)}>
                                                                                                                    <div className="text-white-v1">100</div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div className="col-4 col-md-4 px-1">
                                                                                                                <div className="card-amount mt-2 text-white-v1"
                                                                                                                    onClick={(e) => this.handleClickdeposit(e, 300)}>
                                                                                                                    <div className="text-white-v1">300</div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div className="col-4 col-md-4 px-1">
                                                                                                                <div className="card-amount mt-2 text-white-v1" onClick={(e) => this.handleClickdeposit(e, 500)}>
                                                                                                                    <div className="text-white-v1">500</div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div className="col-4 col-md-4 px-1">
                                                                                                                <div className="card-amount mt-2 text-white-v1" onClick={(e) => this.handleClickdeposit(e, 1000)}>
                                                                                                                    <div className="text-white-v1">1,000</div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div className="col-4 col-md-4 px-1">
                                                                                                                <div className="card-amount mt-2 text-white-v1" onClick={(e) => this.handleClickdeposit(e, 3000)}>
                                                                                                                    <div className="text-white-v1">3,000</div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div className="col-4 col-md-4 px-1">
                                                                                                                <div className="card-amount mt-2 text-white-v1" onClick={(e) => this.handleClickdeposit(e, 5000)}>
                                                                                                                    <div className="text-white-v1">5,000</div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div className="col-4 col-md-4 px-1">
                                                                                                                <div className="card-amount mt-2 text-white-v1" onClick={(e) => this.handleClickdeposit(e, 10000)}>
                                                                                                                    <div className="text-white-v1">10,000</div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div className="col-4 col-md-4 px-1">
                                                                                                                <div className="card-amount mt-2 text-white-v1" onClick={(e) => this.handleClickdeposit(e, 30000)}>
                                                                                                                    <div className="text-white-v1">30,000</div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div className="col-4 col-md-4 px-1">
                                                                                                                <div className="card-amount mt-2 text-white-v1" onClick={(e) => this.handleClickdeposit(e, 50000)}>
                                                                                                                    <div className="text-white-v1">50,000</div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="pt-2 pb-2">
                                                                                                        <button className="btn -btn-deposit w-100"
                                                                                                            onClick={(e) => this.confirmdeposit(e, 0)}
                                                                                                        >
                                                                                                            <svg
                                                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                                                width={16}
                                                                                                                height={16}
                                                                                                                fill="currentColor"
                                                                                                                className="bi bi-check-circle-fill"
                                                                                                                viewBox="0 0 16 16"
                                                                                                            >
                                                                                                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                                                                                                            </svg>{" "}
                                                                                                            สร้าง QR Code เพื่อชำระ
                                                                                                        </button>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="text-white-v1-deposit text-center">
                                                                            <div className="box-content p-0 animated animatedFadeInUp fadeInUp mt-3">
                                                                                <div className="sub-content p-3">
                                                                                    <div className="d-flex justify-content-between">
                                                                                        <div className="text-white-v1-deposit pt-1">
                                                                                            <img
                                                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e8bbd6d-2594-4c50-3863-029c7e9a3500/public"
                                                                                                alt=""
                                                                                                style={{ width: 30 }}
                                                                                            />{" "}
                                                                                            &nbsp; รับโปรโมชั่นอัตโนมัติ
                                                                                        </div>
                                                                                        <div className="text-white-v1-deposit">
                                                                                            <div className="form-check form-switch">
                                                                                                <input
                                                                                                    className="form-check-input"
                                                                                                    type="checkbox"
                                                                                                    role="switch"
                                                                                                    id="flexSwitchCheckDefault"
                                                                                                    style={{ width: "6em", padding: 12 }}
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        {/**/}
                                                                        {/**/}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row m-0 border-shadow-title" style={{ display: this.state.tabselectsec == 1 ? "" : "none" }}>
                                                                <div className="col-12 p-0 col-sm-7 col-md-7 col-lg-7 col-xl-7 mx-auto my-auto text-white-v1">
                                                                    <div className="p-1 bg-deposit-button example animated animatedFadeInUp fadeInUp">
                                                                        <div className="container p-0 x-margin-top-v3">
                                                                            <div className="row m-0 border-shadow-title">
                                                                                <div className="col-12 p-0 col-sm-12 col-md-12 col-lg-12 col-xl-12 mx-auto my-auto -deposit">
                                                                                    <div className="mt-3 -deposit">
                                                                                        <div className="animated animatedFadeInUp fadeInUp">
                                                                                            <div className="card-promptpay text-center pt-3">
                                                                                                <div className="card-body-promptpay">
                                                                                                    <div className="card card-2-promptpay">
                                                                                                        <div className="card-header card-2-promptpay-header">
                                                                                                            {" "}
                                                                                                            QR Code สำหรับชำระเงิน
                                                                                                        </div>
                                                                                                        <div className="card-body">
                                                                                                            <div className="p-2 mb-2 bg-success-subtle">
                                                                                                                <small className="text">
                                                                                                                    QR Code
                                                                                                                    สามารถสเเกนจ่ายได้เพียงครั้งเดี่ยวเท่านั้นโปรดอย่าสเเกนจ่ายซ้ำ
                                                                                                                </small>
                                                                                                            </div>
                                                                                                            <div className="prt-2">
                                                                                                                <div className="img-qr-code">
                                                                                                                    {this.state.qrcode !== null ?
                                                                                                                        <img
                                                                                                                            src={this.state.qrcode}
                                                                                                                            className="-img-text-promotion img-fluid ls-is-cached lazyloaded"
                                                                                                                            alt=""
                                                                                                                            style={{ backgroundColor: "black", height: 196, width: 196 }}
                                                                                                                            height={196}
                                                                                                                            width={196}
                                                                                                                        /> : ""
                                                                                                                    }
                                                                                                                </div>
                                                                                                                <div className="qtx-number pt-2">
                                                                                                                    <h5 className="font-qtx-number">
                                                                                                                        <b>
                                                                                                                            {this.state.depositamount}{" "}
                                                                                                                            <span>
                                                                                                                                <img
                                                                                                                                    className="lang-type-bath"
                                                                                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/d729c93e-e40d-4c6f-db8b-be26f954d200/public"
                                                                                                                                    alt=""
                                                                                                                                />
                                                                                                                            </span>
                                                                                                                        </b>
                                                                                                                    </h5>
                                                                                                                </div>
                                                                                                                <hr className="m-1" />
                                                                                                                <div className="qtx-date-time">
                                                                                                                    <h5 className="font-qtx-date-time m-0">
                                                                                                                        <b>{this.state.counter > 0 ? this.state.counter + " วินาที" : ""} </b>
                                                                                                                    </h5>
                                                                                                                    <h5 className="text-danger remark-date-time m-0">
                                                                                                                        โปรดชำระเงินภายในเวลาที่กำหนด
                                                                                                                    </h5>
                                                                                                                </div>
                                                                                                                <hr className="m-1" />
                                                                                                                <div className="bg-success-subtle p-2 mb-2 text-color-details">
                                                                                                                    <div className="font-details-qr-code">
                                                                                                                        {" "}
                                                                                                                        หากเกิดปัญหาฝากเงินหรืออื่นๆ
                                                                                                                        กรุณาติดต่อเจ้าหน้าที่{" "}
                                                                                                                        <b className="text-danger">
                                                                                                                            <a role="button">
                                                                                                                                Line ID : {this.state.linelink}
                                                                                                                            </a>
                                                                                                                        </b>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <a role="button" className="btn btn-danger w-100">
                                                                                                                    <svg xmlns="http://www.w3.org/2000/svg"
                                                                                                                        width={16}
                                                                                                                        height={16}
                                                                                                                        fill="currentColor"
                                                                                                                        className="bi bi-x-circle-fill"
                                                                                                                        viewBox="0 0 16 16"
                                                                                                                    >
                                                                                                                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                                                                                                                    </svg>{" "}
                                                                                                                    {this.state.counter > 0 ? "ยกเลิกรายการ" : "กรุณาทำรายการใหม่"}
                                                                                                                </a>
                                                                                                                {/**/}
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="text-white-v1-deposit text-center">
                                                                            <div className="box-content p-0 animated animatedFadeInUp fadeInUp mt-3">
                                                                                <div className="sub-content p-3">
                                                                                    <div className="d-flex justify-content-between">
                                                                                        <div className="text-white-v1-deposit pt-1">
                                                                                            <img
                                                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e8bbd6d-2594-4c50-3863-029c7e9a3500/public"
                                                                                                alt=""
                                                                                                style={{ width: 30 }}
                                                                                            />{" "}
                                                                                            &nbsp; รับโปรโมชั่นอัตโนมัติ
                                                                                        </div>
                                                                                        <div className="text-white-v1-deposit">
                                                                                            <div className="form-check form-switch">
                                                                                                <input
                                                                                                    className="form-check-input"
                                                                                                    type="checkbox"
                                                                                                    role="switch"
                                                                                                    id="flexSwitchCheckDefault"
                                                                                                    style={{ width: "6em", padding: 12 }}
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        {/**/}
                                                                        {/**/}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row m-0 border-shadow-title" style={{ display: this.state.tabselectdeposit == 3 ? "" : "none" }}>
                                                                <div className="col-12 p-0 col-sm-7 col-md-7 col-lg-7 col-xl-7 mx-auto my-auto text-white-v1">
                                                                    <div className="p-1 bg-deposit-button example animated animatedFadeInUp fadeInUp">
                                                                        <div className="mt-3">
                                                                            <div className="x-login-index">
                                                                                <div>
                                                                                    <div>
                                                                                        <div className="mt-3">
                                                                                            <div className="text-white-v1-deposit">
                                                                                                <div>
                                                                                                    <div>
                                                                                                        {trueaccount !== null ?
                                                                                                            <div className="text-white-v1-deposit text-center">
                                                                                                                <h6 className="mb-2 mt-2 text-center">
                                                                                                                    <u>โอนเข้าบัญชี</u>
                                                                                                                </h6>
                                                                                                                <div>
                                                                                                                    <div className="flex justify-between mb-1 mx-auto box-content">
                                                                                                                        <div className="sub-content w-100 p-3 px-lg-5">
                                                                                                                            <div className="text-center">
                                                                                                                                <img
                                                                                                                                    className="rounded-full w-10 mb-2 flex"
                                                                                                                                    src="https://play-lh.googleusercontent.com/6I2IYbIg4rhGUgs0UxP_5q6wmJmlBjBrlQ9f0_FAN94yOzwmrtEteifCdPPd1-chY_NX"
                                                                                                                                    style={{ width: 38 }}
                                                                                                                                />{" "}
                                                                                                                                &nbsp;วอลเลท
                                                                                                                            </div>
                                                                                                                            <div className="text-center">
                                                                                                                                {trueaccount.name} :&nbsp; {
                                                                                                                                    trueaccount.telnumber
                                                                                                                                }
                                                                                                                            </div>
                                                                                                                            <div className="text-center pt-2">
                                                                                                                                <a href={() => false} style={{ cursor: "pointer" }}
                                                                                                                                    //  onClick={() => navigator.clipboard.writeText(trueaccount.telnumber)}
                                                                                                                                    onClick={() => this.copyCode(trueaccount.telnumber)}
                                                                                                                                >
                                                                                                                                    <div
                                                                                                                                        className="btn v-login"
                                                                                                                                        style={{
                                                                                                                                            fontSize: 16,
                                                                                                                                            cursor: "pointer"
                                                                                                                                        }}
                                                                                                                                    >
                                                                                                                                        วอลลเท :&nbsp;{" "}
                                                                                                                                        <span id="copy-banktransfer">
                                                                                                                                            {trueaccount.telnumber}
                                                                                                                                        </span>{" "}
                                                                                                                                        &nbsp;&nbsp;
                                                                                                                                        <span
                                                                                                                                            className="badge text-bg-white p-1"
                                                                                                                                            style={{
                                                                                                                                                borderRadius: "33.9916px"
                                                                                                                                            }}
                                                                                                                                        >
                                                                                                                                            &nbsp; คัดลอก &nbsp;
                                                                                                                                        </span>
                                                                                                                                    </div>
                                                                                                                                </a>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            : ""}
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="text-white-v1-deposit text-center">
                                                                            <div className="box-content p-0 animated animatedFadeInUp fadeInUp mt-3">
                                                                                <div className="sub-content p-3">
                                                                                    <div className="d-flex justify-content-between">
                                                                                        <div className="text-white-v1-deposit pt-1">
                                                                                            <img
                                                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e8bbd6d-2594-4c50-3863-029c7e9a3500/public"
                                                                                                alt=""
                                                                                                style={{ width: 30 }}
                                                                                            />{" "}
                                                                                            &nbsp; รับโปรโมชั่นอัตโนมัติ
                                                                                        </div>
                                                                                        <div className="text-white-v1-deposit">
                                                                                            <div className="form-check form-switch">
                                                                                                <input
                                                                                                    className="form-check-input"
                                                                                                    type="checkbox"
                                                                                                    role="switch"
                                                                                                    id="flexSwitchCheckDefault"
                                                                                                    style={{ width: "6em", padding: 12 }}
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        {/**/}
                                                                        {/**/}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                    <div style={{ display: this.state.tabselect == 2 ? "" : "none" }}>
                                        <div>
                                            <br />
                                            <br />
                                            <br />
                                        </div>
                                        <section className="-contact-wrapper row m-0">
                                            <div className="-games-provider-wrapper pl-0 pr-0 mx-auto -menu-index-page-bg col-12">
                                                {/**/}
                                            </div>
                                            <div className="-games-index-page col-12">
                                                <div className="mb-2 text-white-v1">
                                                    <div className="d-none d-lg-block">
                                                        <div>
                                                            <br />
                                                            <br />
                                                            <br />
                                                        </div>
                                                        {/**/}
                                                        {/**/}
                                                        <div>{/**/}</div>
                                                        {/**/}
                                                        {/**/}
                                                    </div>
                                                    {/**/}
                                                    <div className="padding-router-view">
                                                        <div>
                                                            <div className="row m-0 border-shadow-title" >
                                                                <div className="col-12 p-0 col-sm-7 col-md-7 col-lg-7 col-xl-7 mx-auto my-auto text-white-v1">
                                                                    <div className="text-center bg-title-web">
                                                                        <div>
                                                                            <div className="text-title text-white-v1 text-center">
                                                                                <div className="d-flex justify-content-between">
                                                                                    <div className="text-white-v1-deposit" href='/'>
                                                                                        <a role="button" onClick={(e) => {
                                                                                            this.checkurl(e, "/")
                                                                                        }}>
                                                                                            <svg
                                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                                width={25}
                                                                                                height={25}
                                                                                                fill="currentColor"
                                                                                                className="bi bi-arrow-left-circle text-color-back"
                                                                                                viewBox="0 0 16 16"
                                                                                            >
                                                                                                <path
                                                                                                    fillRule="evenodd"
                                                                                                    d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"
                                                                                                />
                                                                                            </svg>
                                                                                        </a>
                                                                                    </div>
                                                                                    <div className="text-white-v1-deposit">
                                                                                        <h5>ถอนเงิน</h5>
                                                                                    </div>
                                                                                    <div>{/**/}</div>
                                                                                </div>
                                                                                <hr className="mt-0" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="x-login-index animated animatedFadeInUp fadeInUp">
                                                                        <div>
                                                                            <div className="pt-1 pb-1">
                                                                                <ul className="nav nav-tabs d-flex justify-content-center">
                                                                                    <li className="nav-item text-center w-50">
                                                                                        <a
                                                                                            className="nav-link active"
                                                                                            aria-current="page"
                                                                                            href="#"
                                                                                        >
                                                                                            <img
                                                                                                className="img-bank-title"
                                                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/7c0dc589-eb20-4725-98df-0531730fff00/public"
                                                                                                alt=""
                                                                                            />{" "}
                                                                                            ธนาคาร
                                                                                        </a>
                                                                                    </li>
                                                                                    {/* <li className="nav-item text-center w-50">
                      <a className="nav-link" aria-current="page" href="#">
                        <img
                          className="img-bank-title"
                          src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a152f75f-0588-49aa-2836-4d9528f69000/public"
                          alt=""
                        />{" "}
                        ทรูมันนี่
                      </a>
                    </li> */}
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div className="row m-0 border-shadow-title" >
                                                                <div className="col-12 p-0 col-sm-7 col-md-7 col-lg-7 col-xl-7 mx-auto my-auto text-white-v1">
                                                                    <div className="p-1 bg-deposit-button example animated animatedFadeInUp fadeInUp">
                                                                        <div className="p-0 x-margin-top-v3">
                                                                            <div className="border-shadow-title">
                                                                                <div>
                                                                                    <div className="mt-2 text-white-v1">
                                                                                        <div>
                                                                                            <div>
                                                                                                <div>
                                                                                                    <div>
                                                                                                        <div>
                                                                                                            <div className="text-white-v1">
                                                                                                                <div>
                                                                                                                    <div className="mb-1">
                                                                                                                        <label
                                                                                                                            htmlFor="price"
                                                                                                                            className="mt-1 mb-1 text-left"
                                                                                                                        >
                                                                                                                            จำนวนเงิน
                                                                                                                        </label>
                                                                                                                        <div className="-x-input-icon flex-column">
                                                                                                                            <div className="input-group mb-1">
                                                                                                                                <input
                                                                                                                                    id="withdraw_amount"
                                                                                                                                    onChange={this.onChange}
                                                                                                                                    name="withdrawamount"
                                                                                                                                    value={this.state.withdrawamount}
                                                                                                                                    className="form-control"
                                                                                                                                    placeholder={0}
                                                                                                                                    aria-label={0}
                                                                                                                                    aria-describedby="basic-addon1"
                                                                                                                                />
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                    <div className="mb-1">
                                                                                                                        <label
                                                                                                                            htmlFor="price"
                                                                                                                            className="mt-1 mb-1 text-left"
                                                                                                                        >
                                                                                                                            เลือกจำนวน
                                                                                                                        </label>
                                                                                                                        <div className="mb-4 row m-0">
                                                                                                                            <div className="col-4 col-md-4 px-1">
                                                                                                                                <div className="card-amount mt-2 text-white-v1" onClick={(e) => this.handleClick(e, 100)}>
                                                                                                                                    <div className="text-white-v1">
                                                                                                                                        100
                                                                                                                                    </div>
                                                                                                                                </div>
                                                                                                                            </div>
                                                                                                                            <div className="col-4 col-md-4 px-1">
                                                                                                                                <div className="card-amount mt-2 text-white-v1" onClick={(e) => this.handleClick(e, 300)}>
                                                                                                                                    <div className="text-white-v1">
                                                                                                                                        300
                                                                                                                                    </div>
                                                                                                                                </div>
                                                                                                                            </div>
                                                                                                                            <div className="col-4 col-md-4 px-1">
                                                                                                                                <div className="card-amount mt-2 text-white-v1" onClick={(e) => this.handleClick(e, 500)}>
                                                                                                                                    <div className="text-white-v1">
                                                                                                                                        500
                                                                                                                                    </div>
                                                                                                                                </div>
                                                                                                                            </div>
                                                                                                                            <div className="col-4 col-md-4 px-1">
                                                                                                                                <div className="card-amount mt-2 text-white-v1" onClick={(e) => this.handleClick(e, 1000)}>
                                                                                                                                    <div className="text-white-v1">
                                                                                                                                        1,000
                                                                                                                                    </div>
                                                                                                                                </div>
                                                                                                                            </div>
                                                                                                                            <div className="col-4 col-md-4 px-1">
                                                                                                                                <div className="card-amount mt-2 text-white-v1" onClick={(e) => this.handleClick(e, 3000)}>
                                                                                                                                    <div className="text-white-v1">
                                                                                                                                        3,000
                                                                                                                                    </div>
                                                                                                                                </div>
                                                                                                                            </div>
                                                                                                                            <div className="col-4 col-md-4 px-1">
                                                                                                                                <div className="card-amount mt-2 text-white-v1" onClick={(e) => this.handleClick(e, 5000)}>
                                                                                                                                    <div className="text-white-v1">
                                                                                                                                        5,000
                                                                                                                                    </div>
                                                                                                                                </div>
                                                                                                                            </div>
                                                                                                                            <div className="col-4 col-md-4 px-1">
                                                                                                                                <div className="card-amount mt-2 text-white-v1" onClick={(e) => this.handleClick(e, 10000)}>
                                                                                                                                    <div className="text-white-v1">
                                                                                                                                        10,000
                                                                                                                                    </div>
                                                                                                                                </div>
                                                                                                                            </div>
                                                                                                                            <div className="col-4 col-md-4 px-1">
                                                                                                                                <div className="card-amount mt-2 text-white-v1" onClick={(e) => this.handleClick(e, 30000)}>
                                                                                                                                    <div className="text-white-v1">
                                                                                                                                        30,000
                                                                                                                                    </div>
                                                                                                                                </div>
                                                                                                                            </div>
                                                                                                                            <div className="col-4 col-md-4 px-1">
                                                                                                                                <div className="card-amount mt-2 text-white-v1" onClick={(e) => this.handleClick(e, 50000)}>
                                                                                                                                    <div className="text-white-v1">
                                                                                                                                        50,000
                                                                                                                                    </div>
                                                                                                                                </div>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                {/**/}
                                                                                                                <div>
                                                                                                                    <div className="mt-1 mb-4">
                                                                                                                        <div>
                                                                                                                            <button
                                                                                                                                onClick={(e) => this.submitwithdraw(e)}
                                                                                                                                className="btn -submit js-submit-accept-term v-login btn-success mt-lg-1 mt-0 w-100 p-2">
                                                                                                                                ถัดไป
                                                                                                                            </button>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                {/**/}
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                {/**/}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        {/**/}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {/**/}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                    <div style={{ display: this.state.tabselect == 3 ? "" : "none" }}>
                                        <Statement props={this.state} />
                                    </div>
                                    <div style={{ display: this.state.tabselect == 8 ? "" : "none" }}>
                                        <Profile props={this.state} />
                                    </div>
                                    <div style={{ display: this.state.tabselect == 4 ? "" : "none" }}>
                                        <Afficiate props={this.state} />
                                    </div>
                                    <div style={{ display: this.state.tabselect == 23 ? "" : "none" }}>
                                        <Signin props={this.state} />
                                    </div>
                                    <div style={{ display: this.state.tabselect == 22 ? "" : "none" }}>
                                        <Register props={this.state} />
                                    </div>
                                    <div style={{ display: this.state.tabselect == 25 ? "" : "none" }}>
                                        <Loss props={this.state} />
                                    </div>
                                    <div style={{ display: this.state.tabselect == 7 ? "" : "none" }}>
                                        <Promotion props={this.state} />
                                    </div>
                                    {/* <div style={{ display: this.state.tabselect == 4 ? "" : "none" }}>
                                        <Afficiate props={this.state} />
                                    </div> */}
                                    <div style={{ display: this.state.tabselect == 16 ? "" : "none" }}>
                                        <div className="padding-router-view">
                                            <div className="container p-0 x-margin-top-v3">
                                                <div className="row m-0 border-shadow-title">
                                                    <div className="col-12 p-0 col-sm-7 col-md-7 col-lg-7 col-xl-7 mx-auto my-auto text-white-v1">
                                                        <div className="text-center bg-title-web">
                                                            <div>
                                                                <div className="text-title text-white-v1 text-center">
                                                                    <div className="d-flex justify-content-between">
                                                                        <div className="text-white-v1-deposit">
                                                                            <a role="button" onClick={(e) => {
                                                                                this.checkurl(e, "/")
                                                                            }}>
                                                                                <svg
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                    width={25}
                                                                                    height={25}
                                                                                    fill="currentColor"
                                                                                    className="bi bi-arrow-left-circle text-color-back"
                                                                                    viewBox="0 0 16 16"
                                                                                >
                                                                                    <path
                                                                                        fillRule="evenodd"
                                                                                        d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"
                                                                                    />
                                                                                </svg>
                                                                            </a>
                                                                        </div>
                                                                        <div className="text-white-v1-deposit">
                                                                            <h5>กิจกรรม</h5>
                                                                        </div>
                                                                        <div>{/**/}</div>
                                                                    </div>
                                                                    <hr className="mt-0" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            className="bg-event-box animated animatedFadeInUp fadeInUp"
                                                            data-v-8a7c0ea5=""
                                                        >
                                                            <div className="banner-event" data-v-8a7c0ea5="">
                                                                <div className="px-0 card-width-banner" data-v-8a7c0ea5="">
                                                                    <div
                                                                        className="flicking-viewport"
                                                                        data-v-8a7c0ea5=""
                                                                        style={{
                                                                            userSelect: "none",
                                                                            WebkitUserDrag: "none",
                                                                            touchAction: "pan-y"
                                                                        }}
                                                                    >
                                                                        <Slider {...settings}>
                                                                            <div
                                                                                className="-slide-inner-wrapper  -slick-item slick-slide slick-cloned "
                                                                                data-slick-index={-2}
                                                                                aria-hidden="true"
                                                                                tabIndex={-1}

                                                                            >
                                                                                <div className="-link-wrapper" style={{ paddingRight: "10px" }}>
                                                                                    <picture>
                                                                                        <img
                                                                                            className="img-fluid -slick-item -item-9"
                                                                                            src="/build/web/igame-index-lobby-wm/img/121.jpg"
                                                                                            alt="First slide"
                                                                                            width={1200}
                                                                                            height={590}
                                                                                            style={{ borderRadius: "0.5rem !important" }}
                                                                                        />
                                                                                    </picture>
                                                                                </div>
                                                                            </div>
                                                                            <div
                                                                                className="-slide-inner-wrapper  -slick-item slick-slide slick-cloned "
                                                                                data-slick-index={-1}
                                                                                aria-hidden="true"
                                                                                tabIndex={-1}

                                                                            >
                                                                                <div className="-link-wrapper" style={{ paddingRight: "10px" }}>
                                                                                    <picture>
                                                                                        <img
                                                                                            className="img-fluid -slick-item -item-9"
                                                                                            src="/build/web/igame-index-lobby-wm/img/122.jpg"
                                                                                            alt="First slide"
                                                                                            width={1200}
                                                                                            height={590}
                                                                                            style={{ borderRadius: "0.5rem !important" }}
                                                                                        />
                                                                                    </picture>
                                                                                </div>
                                                                            </div>
                                                                            <div
                                                                                className="-slide-inner-wrapper  -slick-item slick-slide slick-cloned "
                                                                                data-slick-index={-1}
                                                                                aria-hidden="true"
                                                                                tabIndex={-1}
                                                                            >
                                                                                <div className="-link-wrapper" style={{ paddingRight: "10px" }}>
                                                                                    <picture>
                                                                                        <img
                                                                                            className="img-fluid -slick-item -item-9"
                                                                                            src="/build/web/igame-index-lobby-wm/img/123.jpg"
                                                                                            alt="First slide"
                                                                                            width={1200}
                                                                                            height={590}
                                                                                            style={{ borderRadius: "0.5rem !important" }}
                                                                                        />
                                                                                    </picture>
                                                                                </div>
                                                                            </div>
                                                                        </Slider >
                                                                        <div
                                                                            className="flicking-pagination flicking-pagination-bullets"
                                                                            data-v-8a7c0ea5=""
                                                                        >
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row m-1" data-v-8a7c0ea5="">
                                                                <div className="col-6 p-0" data-v-8a7c0ea5="">
                                                                    <div className="border-box-credit" data-v-8a7c0ea5="">
                                                                        <div
                                                                            className="d-flex justify-content-between"
                                                                            data-v-8a7c0ea5=""
                                                                        >
                                                                            <div className="icon" data-v-8a7c0ea5="">
                                                                                <div data-v-8a7c0ea5="">
                                                                                    <div
                                                                                        role="button"
                                                                                        className="d-flex justify-content-between"
                                                                                        data-v-8a7c0ea5=""
                                                                                    >
                                                                                        <div data-v-8a7c0ea5="">
                                                                                            <small
                                                                                                className="font-play-refer"
                                                                                                data-v-8a7c0ea5=""
                                                                                            >
                                                                                                ยอดเงินในเกม
                                                                                            </small>
                                                                                            <div
                                                                                                className="text-white d-flex align-items-center"
                                                                                                data-v-8a7c0ea5=""
                                                                                            >
                                                                                                <span data-v-8a7c0ea5="">
                                                                                                    <img
                                                                                                        className="lang-type-bath"
                                                                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/d729c93e-e40d-4c6f-db8b-be26f954d200/public"
                                                                                                        alt=""
                                                                                                        data-v-8a7c0ea5=""
                                                                                                    />
                                                                                                </span>
                                                                                                <b
                                                                                                    className="p-2-l-r-box-event"
                                                                                                    data-v-8a7c0ea5=""
                                                                                                >
                                                                                                    0
                                                                                                </b>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="icon" data-v-8a7c0ea5="">
                                                                                <a
                                                                                    onClick={(e) => {
                                                                                        this.checkurl(e, "/")
                                                                                    }}
                                                                                    role="button"
                                                                                    id="icon-refresh-credit"
                                                                                    className="mt-2 mb-2"
                                                                                    data-v-8a7c0ea5=""
                                                                                >
                                                                                    <span data-v-8a7c0ea5="">
                                                                                        <svg
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                            width={15}
                                                                                            height={15}
                                                                                            fill="currentColor"
                                                                                            className="bi bi-arrow-clockwise text-white-v1"
                                                                                            viewBox="0 0 16 16"
                                                                                            data-v-8a7c0ea5=""
                                                                                        >
                                                                                            <path
                                                                                                fillRule="evenodd"
                                                                                                d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
                                                                                                data-v-8a7c0ea5=""
                                                                                            />
                                                                                            <path
                                                                                                d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"
                                                                                                data-v-8a7c0ea5=""
                                                                                            />
                                                                                        </svg>
                                                                                    </span>
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row animated animatedFadeInUp fadeInUp">
                                                            <div className="col-lg-4 text-center p-1 col-3">
                                                                <a role='button' onClick={(e) => {
                                                                    this.checkurl(e, "/refer/overview")
                                                                }} >
                                                                    <div className="bg-card-item m-1" >
                                                                        <div className="p-1 bg-mission-button example">
                                                                            <img
                                                                                className="w-100 img-hover-event"
                                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/27853edf-e63b-44fe-d4f0-ca075d6e2a00/public"
                                                                                alt=""
                                                                            />
                                                                        </div>
                                                                        <div className="p-1">
                                                                            <div className="name-progress-circle-number text-name text-ellipsis align-items-center">
                                                                                <b className="font-event-size-1 text-ellipsis">
                                                                                    แนะนำเพื่อน
                                                                                </b>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            <div className="col-lg-4 text-center p-1 col-3">
                                                                <a
                                                                    role='button' onClick={(e) => {
                                                                        this.checkurl(e, "/loss")
                                                                    }} >
                                                                    <div className="bg-card-item m-1">
                                                                        <div className="p-1 bg-mission-button example">
                                                                            <img
                                                                                className="w-100 img-hover-event"
                                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/9dde2261-a3f8-4237-af7b-7566b82b0700/public"
                                                                                alt=""
                                                                            />
                                                                        </div>
                                                                        <div className="p-1">
                                                                            <div className="name-progress-circle-number text-name text-ellipsis align-items-center">
                                                                                <b className="font-event-size-1 text-ellipsis">
                                                                                    คืนยอดเสีย
                                                                                </b>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            <div className="col-lg-4 text-center p-1 col-3">
                                                                <a
                                                                    role='button' onClick={(e) => {
                                                                        this.checkurl(e, "/promotion")
                                                                    }}>
                                                                    <div className="bg-card-item m-1">
                                                                        <div className="p-1 bg-mission-button example">
                                                                            <img
                                                                                className="w-100 img-hover-event"
                                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/211a5b05-cd76-41f5-cd5b-396825326500/public"
                                                                                alt=""
                                                                            />
                                                                        </div>
                                                                        <div className="p-1">
                                                                            <div className="name-progress-circle-number text-name text-ellipsis align-items-center">
                                                                                <b className="font-event-size-1 text-ellipsis">
                                                                                    โปรโมชั่น
                                                                                </b>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            {/* <div className="col-lg-4 text-center p-1 col-3">
                                                <a href="/promotion" >
                                                    <div className="bg-card-item m-1">
                                                        <div className="p-1 bg-mission-button example">
                                                            <img
                                                                className="w-100 img-hover-event"
                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/57a68c1c-3257-422e-c072-2b2bbf0f8200/public"
                                                                alt=""
                                                            />
                                                        </div>
                                                        <div className="p-1">
                                                            <div className="name-progress-circle-number text-name text-ellipsis align-items-center">
                                                                <b className="font-event-size-1 text-ellipsis">
                                                                    ภารกิจ
                                                                </b>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    </a>
                                                </div> */}
                                                            {/* <div className="col-lg-4 text-center p-1 col-3">
                                                    <div className="bg-card-item m-1">
                                                        <div className="p-1 bg-mission-button example">
                                                            <img
                                                                className="w-100 img-hover-event"
                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/7e052147-f4f9-44b6-25cd-ffc0d45c7600/public"
                                                                alt=""
                                                            />
                                                        </div>
                                                        <div className="p-1">
                                                            <div className="name-progress-circle-number text-name text-ellipsis align-items-center">
                                                                <b className="font-event-size-1 text-ellipsis">
                                                                    กิจกรรมเปิดไพ่
                                                                </b>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> */}
                                                            <div className="col-lg-4 text-center p-1 col-3">
                                                                <div className="bg-card-item m-1">
                                                                    <div className="p-1 bg-mission-button example">
                                                                        <img
                                                                            className="w-100 img-hover-event"
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/fb674130-3318-46c3-c482-dd8a0c938700/public"
                                                                            alt=""
                                                                        />
                                                                    </div>
                                                                    <div className="p-1">
                                                                        <div className="name-progress-circle-number text-name text-ellipsis align-items-center">
                                                                            <b className="font-event-size-1 text-ellipsis">
                                                                                แลกของรางวัล
                                                                            </b>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-4 text-center p-1 col-3">
                                                                <div className="bg-card-item m-1">
                                                                    <div className="p-1 bg-mission-button example">
                                                                        <img
                                                                            className="w-100 img-hover-event"
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/d8563ba2-b284-4bad-4313-dc02549bd200/public"
                                                                            alt=""
                                                                        />
                                                                    </div>
                                                                    <div className="p-1">
                                                                        <div className="name-progress-circle-number text-name text-ellipsis align-items-center">
                                                                            <b className="font-event-size-1 text-ellipsis">
                                                                                คืนยอดเดิมพัน
                                                                            </b>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-4 text-center p-1 col-3">
                                                                <div className="bg-card-item m-1">
                                                                    <div className="p-1 bg-mission-button example">
                                                                        <img
                                                                            className="w-100 img-hover-event"
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/caf1df64-acb0-41ad-6cae-4f2f85b89c00/public"
                                                                            alt=""
                                                                        />
                                                                    </div>
                                                                    <div className="p-1">
                                                                        <div className="name-progress-circle-number text-name text-ellipsis align-items-center">
                                                                            <b className="font-event-size-1 text-ellipsis">
                                                                                จัดอันดับ
                                                                            </b>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <Lowmenu />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="base-modal-overlay x-modal modal -v2 x-theme-switcher-v2 show animated animatedFadeInUp fadeInUp"
                    // style={{ display: this.state.modal ? "" : "none" }}
                    data-v-8bc7c3b9=""
                >
                    <div
                        className="base-modal pt-0 pb-0 w-100"
                        data-v-8bc7c3b9=""
                        style={{ margin: 10, textAlign: "-webkit-center" }}
                    >
                        <div
                            className="modal-dialog -modal-size -v2 modal-dialog-centered modal-dialog-scrollable modal-dialog-centered w-100 m-0"
                            data-v-8bc7c3b9=""
                            style={{ height: "auto" }}
                        >
                            <div
                                className="modal-content -modal-content text-white-v1"
                                data-v-8bc7c3b9=""
                            >
                                <a
                                    role="button"
                                    className="close-model-head mt-4 mb-4"
                                    data-v-8bc7c3b9=""
                                    onClick={(e) => {
                                        this.setState({
                                            modal: false
                                        });
                                    }}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={30}
                                        height={30}
                                        fill="currentColor"
                                        className="bi bi-x-circle-fill"
                                        viewBox="0 0 16 16"
                                        data-v-8bc7c3b9=""
                                    >
                                        <path
                                            d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"
                                            data-v-8bc7c3b9=""
                                        />
                                    </svg>
                                </a>
                                {/**/}
                                <div
                                    className="pt-3 pb-4 x-theme-switcher-v2 text-center mt-3"
                                    data-v-8bc7c3b9=""
                                >
                                    <div className="-inner-header-section" data-v-8bc7c3b9="">
                                        <img
                                            src="/build/web/igame-index-lobby-wm/img/logo.png?v=1"
                                            alt=""
                                            data-v-8bc7c3b9=""
                                            style={{ width: 160 }}
                                        />
                                        <div className="mt-1 mb-1 w-100" data-v-8bc7c3b9="" style={{ marginTop: "-30px" }}>
                                            <h3 className="title-footer-wrap pt-2">
                                                <b>Language / ภาษา </b>
                                            </h3>
                                            <ul className="logo-list-footer">
                                                <li role="button">
                                                    <img
                                                        className="lang-img active-lang"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e1626da-cc1f-451f-838f-54e5e1848f00/public"
                                                        alt=""
                                                    />
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div
                                        className="row -inner-center-body-section m-0"
                                        style={{ color: "white" }}
                                        data-v-8bc7c3b9=""
                                    >
                                        <div className="col-6 -wrapper-box" data-v-8bc7c3b9="">
                                            <a
                                                onClick={(e) => {
                                                    this.checkurl(e, "/profile")
                                                }}
                                                role="button"
                                                className="btn -btn-item -event-button -menu-center -horizontal"
                                                data-v-8bc7c3b9=""
                                            >
                                                <picture data-v-8bc7c3b9="">
                                                    <source
                                                        type="image/webp"
                                                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/3066ed62-07f3-4623-b4c0-ac1d1eb7e300/public"
                                                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/3066ed62-07f3-4623-b4c0-ac1d1eb7e300/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <source
                                                        type="image/png?v=1"
                                                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/3066ed62-07f3-4623-b4c0-ac1d1eb7e300/public"
                                                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/3066ed62-07f3-4623-b4c0-ac1d1eb7e300/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <img
                                                        className="img-fluid -icon-image ls-is-cached lazyloaded"
                                                        data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/3066ed62-07f3-4623-b4c0-ac1d1eb7e300/public"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/3066ed62-07f3-4623-b4c0-ac1d1eb7e300/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                </picture>
                                                <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                                    <div className="-typo -is-logged" data-v-8bc7c3b9="">
                                                        <span data-v-8bc7c3b9="" >ข้อมูลบัญชี</span>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="col-6 -wrapper-box" data-v-8bc7c3b9="">
                                            <a
                                                onClick={(e) => {
                                                    this.checkurl(e, "/loss")
                                                }}
                                                role="button"
                                                className="btn -btn-item -event-button -menu-center -horizontal"
                                                data-v-8bc7c3b9=""
                                            >
                                                <picture data-v-8bc7c3b9="">
                                                    <source
                                                        type="image/webp"
                                                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5ab912d5-9d59-4e39-f3fa-f108d3d62500/public"
                                                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5ab912d5-9d59-4e39-f3fa-f108d3d62500/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <source
                                                        type="image/png?v=1"
                                                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5ab912d5-9d59-4e39-f3fa-f108d3d62500/public"
                                                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5ab912d5-9d59-4e39-f3fa-f108d3d62500/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <img
                                                        className="img-fluid -icon-image ls-is-cached lazyloaded"
                                                        data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5ab912d5-9d59-4e39-f3fa-f108d3d62500/public"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5ab912d5-9d59-4e39-f3fa-f108d3d62500/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                </picture>
                                                <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                                    <div className="-typo -is-logged" data-v-8bc7c3b9="">
                                                        <span data-v-8bc7c3b9="">คืนยอดเสีย</span>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="col-6 -wrapper-box" data-v-8bc7c3b9="">
                                            <a
                                                onClick={(e) => {
                                                    this.checkurl(e, "/refer/overview")
                                                }}
                                                role="button"
                                                className="btn -btn-item -event-button -menu-center -horizontal"
                                                data-v-8bc7c3b9=""
                                            >
                                                <picture data-v-8bc7c3b9="">
                                                    <source
                                                        type="image/webp"
                                                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8497de75-3140-4e19-9747-a03adb7c7700/public"
                                                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8497de75-3140-4e19-9747-a03adb7c7700/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <source
                                                        type="image/png?v=1"
                                                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8497de75-3140-4e19-9747-a03adb7c7700/public"
                                                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8497de75-3140-4e19-9747-a03adb7c7700/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <img
                                                        className="img-fluid -icon-image ls-is-cached lazyloaded"
                                                        data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8497de75-3140-4e19-9747-a03adb7c7700/public"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8497de75-3140-4e19-9747-a03adb7c7700/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                </picture>
                                                <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                                    <div className="-typo -is-logged" data-v-8bc7c3b9="">
                                                        <span data-v-8bc7c3b9="">เเนะนำเพื่อน</span>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="col-6 -wrapper-box" data-v-8bc7c3b9="">
                                            <a
                                                onClick={(e) => {
                                                    this.checkurl(e, "/statement")
                                                }}
                                                role="button"
                                                className="btn -btn-item -event-button -menu-center -horizontal"
                                                data-v-8bc7c3b9=""
                                            >
                                                <picture data-v-8bc7c3b9="">
                                                    <source
                                                        type="image/webp"
                                                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a2075ee6-ea48-47ed-726b-01a8b6ec8000/public"
                                                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a2075ee6-ea48-47ed-726b-01a8b6ec8000/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <source
                                                        type="image/png?v=1"
                                                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a2075ee6-ea48-47ed-726b-01a8b6ec8000/public"
                                                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a2075ee6-ea48-47ed-726b-01a8b6ec8000/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <img
                                                        className="img-fluid -icon-image ls-is-cached lazyloaded"
                                                        data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a2075ee6-ea48-47ed-726b-01a8b6ec8000/public"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a2075ee6-ea48-47ed-726b-01a8b6ec8000/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                </picture>
                                                <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                                    <div className="-typo -is-logged" data-v-8bc7c3b9="">
                                                        <span data-v-8bc7c3b9="">ประวัติ</span>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="col-6 -wrapper-box" data-v-8bc7c3b9="">
                                            <a
                                                onClick={(e) => {
                                                    this.checkurl(e, "/promotion")
                                                }}
                                                role="button"
                                                className="btn -btn-item -event-button -menu-center -horizontal"
                                                data-v-8bc7c3b9=""
                                            >
                                                <picture data-v-8bc7c3b9="">
                                                    <source
                                                        type="image/webp"
                                                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e8bbd6d-2594-4c50-3863-029c7e9a3500/public"
                                                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e8bbd6d-2594-4c50-3863-029c7e9a3500/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <source
                                                        type="image/png?v=1"
                                                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e8bbd6d-2594-4c50-3863-029c7e9a3500/public"
                                                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e8bbd6d-2594-4c50-3863-029c7e9a3500/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <img
                                                        className="img-fluid -icon-image ls-is-cached lazyloaded"
                                                        data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e8bbd6d-2594-4c50-3863-029c7e9a3500/public"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e8bbd6d-2594-4c50-3863-029c7e9a3500/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                </picture>
                                                <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                                    <div className="-typo -is-logged" data-v-8bc7c3b9="">
                                                        <span data-v-8bc7c3b9="">โปรโมชั่น</span>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        {/* <div className="col-6 -wrapper-box" data-v-8bc7c3b9="">
                      <a
                       href='/promotion'
                        role="button"
                        className="btn -btn-item -event-button -menu-center -horizontal"
                        data-v-8bc7c3b9=""
                      >
                        <picture data-v-8bc7c3b9="">
                          <source
                            type="image/webp"
                            data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/6311559f-81fe-484a-ea3e-30b9d40fb700/public"
                            srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/6311559f-81fe-484a-ea3e-30b9d40fb700/public"
                            data-v-8bc7c3b9=""
                          />
                          <source
                            type="image/png?v=1"
                            data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/6311559f-81fe-484a-ea3e-30b9d40fb700/public"
                            srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/6311559f-81fe-484a-ea3e-30b9d40fb700/public"
                            data-v-8bc7c3b9=""
                          />
                          <img
                            className="img-fluid -icon-image ls-is-cached lazyloaded"
                            data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/6311559f-81fe-484a-ea3e-30b9d40fb700/public"
                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/6311559f-81fe-484a-ea3e-30b9d40fb700/public"
                            data-v-8bc7c3b9=""
                          />
                        </picture>
                        <div className="-typo-wrapper" data-v-8bc7c3b9="">
                          <div className="-typo -is-logged" data-v-8bc7c3b9="">
                            <span data-v-8bc7c3b9="">เเลกของรางวัล</span>
                          </div>
                        </div>
                      </a>
                    </div> */}
                                        {/**/}
                                        <div className="col-6 -wrapper-box" data-v-8bc7c3b9="">
                                            <a
                                                href="/logout"
                                                role="button"
                                                className="btn -btn-item -event-button -menu-center -horizontal"
                                                data-v-8bc7c3b9=""
                                            >
                                                <picture data-v-8bc7c3b9="">
                                                    <source
                                                        type="image/webp"
                                                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/630a8cf7-f7a8-4ff3-0e58-0b9929ce5500/public"
                                                        srcSet="
                  https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/630a8cf7-f7a8-4ff3-0e58-0b9929ce5500/public
                "
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <source
                                                        type="image/png?v=1"
                                                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/630a8cf7-f7a8-4ff3-0e58-0b9929ce5500/public"
                                                        srcSet="
                  https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/630a8cf7-f7a8-4ff3-0e58-0b9929ce5500/public
                "
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <img
                                                        className="img-fluid -icon-image ls-is-cached lazyloaded"
                                                        data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/630a8cf7-f7a8-4ff3-0e58-0b9929ce5500/public"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/630a8cf7-f7a8-4ff3-0e58-0b9929ce5500/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                </picture>
                                                <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                                    <div className="-typo -is-logged" data-v-8bc7c3b9="">
                                                        ออกจากระบบ
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/**/}
                </div>
                <div className="base-modal-overlay x-modal modal -v2 x-theme-switcher-v2 show animated animatedFadeInUp fadeInUp"
                    // style={{ display: this.state.modalx ? "" : "none" }}
                    data-v-8bc7c3b9=""
                >
                    <div
                        className="base-modal pt-0 pb-0 w-100"
                        data-v-8bc7c3b9=""
                        style={{ margin: 10, textAlign: "-webkit-center" }}
                    >
                        <div
                            className="modal-dialog -modal-size -v2 modal-dialog-centered modal-dialog-scrollable modal-dialog-centered w-100 m-0"
                            data-v-8bc7c3b9=""
                            style={{ height: "auto" }}
                        >


                            <div
                                className="modal-content -modal-content text-white-v1"
                                data-v-8bc7c3b9=""
                            >
                                <a
                                    onClick={(e) => {
                                        this.setState({
                                            modalx: false
                                        });
                                    }}
                                    role="button"
                                    className="close-model-head mt-4 mb-4"
                                    data-v-8bc7c3b9=""
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={30}
                                        height={30}
                                        fill="currentColor"
                                        className="bi bi-x-circle-fill"
                                        viewBox="0 0 16 16"
                                        data-v-8bc7c3b9=""
                                    >
                                        <path
                                            d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"
                                            data-v-8bc7c3b9=""
                                        />
                                    </svg>
                                </a>


                                <div className="pt-3 pb-4 x-theme-switcher-v2 text-center mt-3"
                                    data-v-8bc7c3b9=""
                                >
                                    <div className="-inner-header-section" data-v-8bc7c3b9="">
                                        <img
                                            src="/build/web/igame-index-lobby-wm/img/logo.png?v=1"
                                            alt=""
                                            data-v-8bc7c3b9=""
                                            style={{ width: 160 }}
                                        />
                                    </div>
                                    {(loginstate != null) ? (!loginstate) ?
                                        <div className="row -inner-top-body-section" data-v-8bc7c3b9="">
                                            <div
                                                className="col-6 -wrapper-box"
                                                data-v-8bc7c3b9=""
                                                style={{ paddingLeft: 0 }}
                                            >
                                                <a
                                                    onClick={(e) => {
                                                        this.checkurl(e, "/register")
                                                    }}
                                                    type="button"
                                                    className="btn -btn-item x-transaction-button-v2 -deposit -top-btn -horizontal"
                                                    data-v-8bc7c3b9=""
                                                >
                                                    <img
                                                        alt="img webรูปไอคอนฝากเงิน"
                                                        className="img-fluid -icon-image"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/279056cb-32d6-4c6d-7291-44366ffa1500/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                                        <div className="-title" data-v-8bc7c3b9="">
                                                            สมัครสมาชิก
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                            <div
                                                className="col-6 -wrapper-box"
                                                data-v-8bc7c3b9=""
                                                style={{ paddingRight: 0 }}
                                            >
                                                <a
                                                    onClick={(e) => {
                                                        this.checkurl(e, "/signin")
                                                    }}
                                                    type="button"
                                                    className="btn -btn-item x-transaction-button-v2 -withdraw -top-btn -horizontal"

                                                    data-v-8bc7c3b9=""
                                                >
                                                    <img
                                                        alt=" รูปไอคอนถอนเงิน"
                                                        className="img-fluid -icon-image"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/363edcc3-13dc-460b-671d-6a37e3191e00/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                                        <div className="-title" data-v-8bc7c3b9="">
                                                            เข้าสู่ระบบ
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        </div> :
                                        <div className="row -inner-top-body-section" data-v-8bc7c3b9="">
                                            <div
                                                className="col-6 -wrapper-box"
                                                data-v-8bc7c3b9=""
                                                style={{ paddingLeft: 0 }}
                                            >
                                                <a
                                                    onClick={(e) => {
                                                        this.checkurl(e, "/deposit")
                                                    }}
                                                    role="button"
                                                    className="btn -btn-item x-transaction-button-v2 -deposit -top-btn -horizontal"
                                                    data-v-8bc7c3b9=""
                                                >
                                                    <img
                                                        className="img-fluid -icon-image"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/d2a5801c-d49e-4e57-ee32-bcb42682e400/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                                        <div className="-title" data-v-8bc7c3b9="">
                                                            ฝากเงิน
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                            <div
                                                className="col-6 -wrapper-box"
                                                data-v-8bc7c3b9=""
                                                style={{ paddingRight: 0 }}
                                            >
                                                <a
                                                    onClick={(e) => {
                                                        this.checkurl(e, "/withdraw")
                                                    }}
                                                    type="button"
                                                    className="btn -btn-item x-transaction-button-v2 -withdraw -top-btn -horizontal"
                                                    data-v-8bc7c3b9=""
                                                >
                                                    <img
                                                        className="img-fluid -icon-image"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/6829da4a-a4a5-4f8e-2ce0-286825809600/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                                        <div className="-title" data-v-8bc7c3b9="">
                                                            ถอนเงิน
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        </div> : ""}
                                    <div
                                        className="row -inner-center-body-section m-0"
                                        data-v-8bc7c3b9=""
                                    >
                                        <div className="col-6 -wrapper-box" data-v-8bc7c3b9="">
                                            <a
                                                onClick={(e) => {
                                                    this.checkurl(e, "/promotion")
                                                }}
                                                role="button"
                                                className="btn -btn-item -promotion-button -menu-center -horizontal"
                                                data-v-8bc7c3b9=""
                                            >
                                                <img
                                                    alt=" รูปไอคอนโปรโมชั่น"
                                                    className="img-fluid -icon-image ls-is-cached lazyloaded"
                                                    data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e8bbd6d-2594-4c50-3863-029c7e9a3500/public"
                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e8bbd6d-2594-4c50-3863-029c7e9a3500/public"
                                                    data-v-8bc7c3b9=""
                                                />
                                                <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                                    <div className="-typo -is-logged" data-v-8bc7c3b9="">
                                                        โปรโมชั่น
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="col-6 -wrapper-box" data-v-8bc7c3b9="">
                                            <a
                                                href={this.state.linelink}
                                                role="button"
                                                className="btn -btn-item -line-button -menu-center -horizontal"
                                                rel="noopener nofollow"
                                                data-v-8bc7c3b9=""
                                            >
                                                <picture data-v-8bc7c3b9="">
                                                    <source
                                                        type="image/webp"
                                                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a5205298-bde9-4817-4f93-32dc3822b700/public"
                                                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a5205298-bde9-4817-4f93-32dc3822b700/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <source
                                                        type="image/png?v=1"
                                                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a5205298-bde9-4817-4f93-32dc3822b700/public"
                                                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a5205298-bde9-4817-4f93-32dc3822b700/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <img
                                                        className="img-fluid -icon-image ls-is-cached lazyloaded"
                                                        data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a5205298-bde9-4817-4f93-32dc3822b700/public"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a5205298-bde9-4817-4f93-32dc3822b700/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                </picture>
                                                <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                                    <div className="-typo -is-logged" data-v-8bc7c3b9="">
                                                        ติดต่อ
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        {/**/}
                                        <div className="col-12 -wrapper-box" data-v-8bc7c3b9="">
                                            <div
                                                className="btn -btn-item -line-button -menu-center -horizontal"
                                                data-v-8bc7c3b9=""
                                            >
                                                <div className="mt-1 mb-1 w-100" data-v-8bc7c3b9="">
                                                    <h3 className="title-footer-wrap pt-2">
                                                        <b>Language / ภาษา </b>
                                                    </h3>
                                                    <ul className="logo-list-footer">
                                                        <li role="button">
                                                            <img
                                                                className="lang-img active-lang"
                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e1626da-cc1f-451f-838f-54e5e1848f00/public"
                                                                alt=""
                                                            />
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                </div>


                                {/**/}
                            </div>
                        </div>
                    </div>
                    {/**/}
                </div>
                <div className="base-modal-overlay x-modal modal -v2 x-theme-switcher-v2 show animated animatedFadeInUp fadeInUp"
                    data-v-0c0c7fd4=""
                    style={{ display: this.state.modal ? "" : "none" }}
                >
                    <div
                        className="base-modal pt-0 pb-0 w-100"
                        data-v-0c0c7fd4=""
                        style={{ margin: 10, textAlign: "-webkit-center" }}
                    >
                        <div
                            className="modal-dialog -modal-size -v2 modal-dialog-centered modal-dialog-scrollable modal-dialog-centered w-100 m-0"
                            data-v-8bc7c3b9=""
                            style={{ height: "auto" }}
                        >
                            <div
                                className="modal-content -modal-content text-white-v1"
                                data-v-8bc7c3b9=""
                            >
                                <a
                                    role="button"
                                    className="close-model-head mt-4 mb-4"
                                    data-v-8bc7c3b9=""
                                    onClick={(e) => {
                                        this.setState({
                                            modal: false
                                        });
                                    }}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={30}
                                        height={30}
                                        fill="currentColor"
                                        className="bi bi-x-circle-fill"
                                        viewBox="0 0 16 16"
                                        data-v-8bc7c3b9=""
                                    >
                                        <path
                                            d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"
                                            data-v-8bc7c3b9=""
                                        />
                                    </svg>
                                </a>
                                {/**/}
                                <div
                                    className="pt-3 pb-4 x-theme-switcher-v2 text-center mt-3"
                                    data-v-8bc7c3b9=""
                                >
                                    <div className="-inner-header-section" data-v-8bc7c3b9="">
                                        <img
                                            src="/build/web/igame-index-lobby-wm/img/logo.png?v=1"
                                            alt=""
                                            data-v-8bc7c3b9=""
                                            style={{ width: 160 }}
                                        />
                                        <div className="mt-1 mb-1 w-100" data-v-8bc7c3b9="" style={{ marginTop: "-30px" }}>
                                            <h3 className="title-footer-wrap pt-2">
                                                <b>Language / ภาษา </b>
                                            </h3>
                                            <ul className="logo-list-footer">
                                                <li role="button">
                                                    <img
                                                        className="lang-img active-lang"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e1626da-cc1f-451f-838f-54e5e1848f00/public"
                                                        alt=""
                                                    />
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div
                                        className="row -inner-center-body-section m-0"
                                        style={{ color: "white" }}
                                        data-v-8bc7c3b9=""
                                    >
                                        <div className="col-6 -wrapper-box" data-v-8bc7c3b9="">
                                            <a
                                                role="button"
                                                className="btn -btn-item -event-button -menu-center -horizontal"
                                                data-v-8bc7c3b9=""
                                                onClick={(e) => {
                                                    this.checkurl(e, "/profile")
                                                }}
                                            >
                                                <picture data-v-8bc7c3b9="">
                                                    <source
                                                        type="image/webp"
                                                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/3066ed62-07f3-4623-b4c0-ac1d1eb7e300/public"
                                                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/3066ed62-07f3-4623-b4c0-ac1d1eb7e300/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <source
                                                        type="image/png?v=1"
                                                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/3066ed62-07f3-4623-b4c0-ac1d1eb7e300/public"
                                                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/3066ed62-07f3-4623-b4c0-ac1d1eb7e300/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <img
                                                        className="img-fluid -icon-image ls-is-cached lazyloaded"
                                                        data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/3066ed62-07f3-4623-b4c0-ac1d1eb7e300/public"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/3066ed62-07f3-4623-b4c0-ac1d1eb7e300/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                </picture>
                                                <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                                    <div className="-typo -is-logged" data-v-8bc7c3b9="">
                                                        <span data-v-8bc7c3b9="">ข้อมูลบัญชี</span>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="col-6 -wrapper-box" data-v-8bc7c3b9="">
                                            <a
                                                onClick={(e) => {
                                                    this.checkurl(e, "/loss")
                                                }}
                                                role="button"
                                                className="btn -btn-item -event-button -menu-center -horizontal"
                                                data-v-8bc7c3b9=""
                                            >
                                                <picture data-v-8bc7c3b9="">
                                                    <source
                                                        type="image/webp"
                                                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5ab912d5-9d59-4e39-f3fa-f108d3d62500/public"
                                                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5ab912d5-9d59-4e39-f3fa-f108d3d62500/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <source
                                                        type="image/png?v=1"
                                                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5ab912d5-9d59-4e39-f3fa-f108d3d62500/public"
                                                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5ab912d5-9d59-4e39-f3fa-f108d3d62500/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <img
                                                        className="img-fluid -icon-image ls-is-cached lazyloaded"
                                                        data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5ab912d5-9d59-4e39-f3fa-f108d3d62500/public"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5ab912d5-9d59-4e39-f3fa-f108d3d62500/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                </picture>
                                                <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                                    <div className="-typo -is-logged" data-v-8bc7c3b9="">
                                                        <span data-v-8bc7c3b9="">คืนยอดเสีย</span>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="col-6 -wrapper-box" data-v-8bc7c3b9="">
                                            <a
                                                onClick={(e) => {
                                                    this.checkurl(e, "/refer/overview")
                                                }}
                                                role="button"
                                                className="btn -btn-item -event-button -menu-center -horizontal"
                                                data-v-8bc7c3b9=""
                                            >
                                                <picture data-v-8bc7c3b9="">
                                                    <source
                                                        type="image/webp"
                                                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8497de75-3140-4e19-9747-a03adb7c7700/public"
                                                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8497de75-3140-4e19-9747-a03adb7c7700/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <source
                                                        type="image/png?v=1"
                                                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8497de75-3140-4e19-9747-a03adb7c7700/public"
                                                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8497de75-3140-4e19-9747-a03adb7c7700/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <img
                                                        className="img-fluid -icon-image ls-is-cached lazyloaded"
                                                        data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8497de75-3140-4e19-9747-a03adb7c7700/public"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8497de75-3140-4e19-9747-a03adb7c7700/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                </picture>
                                                <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                                    <div className="-typo -is-logged" data-v-8bc7c3b9="">
                                                        <span data-v-8bc7c3b9="">เเนะนำเพื่อน</span>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="col-6 -wrapper-box" data-v-8bc7c3b9="">
                                            <a
                                                onClick={(e) => {
                                                    this.checkurl(e, "/statement")
                                                }}
                                                role="button"
                                                className="btn -btn-item -event-button -menu-center -horizontal"
                                                data-v-8bc7c3b9=""
                                            >
                                                <picture data-v-8bc7c3b9="">
                                                    <source
                                                        type="image/webp"
                                                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a2075ee6-ea48-47ed-726b-01a8b6ec8000/public"
                                                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a2075ee6-ea48-47ed-726b-01a8b6ec8000/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <source
                                                        type="image/png?v=1"
                                                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a2075ee6-ea48-47ed-726b-01a8b6ec8000/public"
                                                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a2075ee6-ea48-47ed-726b-01a8b6ec8000/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <img
                                                        className="img-fluid -icon-image ls-is-cached lazyloaded"
                                                        data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a2075ee6-ea48-47ed-726b-01a8b6ec8000/public"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a2075ee6-ea48-47ed-726b-01a8b6ec8000/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                </picture>
                                                <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                                    <div className="-typo -is-logged" data-v-8bc7c3b9="">
                                                        <span data-v-8bc7c3b9="">ประวัติ</span>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="col-6 -wrapper-box" data-v-8bc7c3b9="">
                                            <a
                                                onClick={(e) => {
                                                    this.checkurl(e, "/promotion")
                                                }}
                                                role="button"
                                                className="btn -btn-item -event-button -menu-center -horizontal"
                                                data-v-8bc7c3b9=""
                                            >
                                                <picture data-v-8bc7c3b9="">
                                                    <source
                                                        type="image/webp"
                                                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e8bbd6d-2594-4c50-3863-029c7e9a3500/public"
                                                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e8bbd6d-2594-4c50-3863-029c7e9a3500/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <source
                                                        type="image/png?v=1"
                                                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e8bbd6d-2594-4c50-3863-029c7e9a3500/public"
                                                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e8bbd6d-2594-4c50-3863-029c7e9a3500/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <img
                                                        className="img-fluid -icon-image ls-is-cached lazyloaded"
                                                        data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e8bbd6d-2594-4c50-3863-029c7e9a3500/public"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e8bbd6d-2594-4c50-3863-029c7e9a3500/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                </picture>
                                                <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                                    <div className="-typo -is-logged" data-v-8bc7c3b9="">
                                                        <span data-v-8bc7c3b9="">โปรโมชั่น</span>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        {/* <div className="col-6 -wrapper-box" data-v-8bc7c3b9="">
                      <a
                       href='/promotion'
                        role="button"
                        className="btn -btn-item -event-button -menu-center -horizontal"
                        data-v-8bc7c3b9=""
                      >
                        <picture data-v-8bc7c3b9="">
                          <source
                            type="image/webp"
                            data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/6311559f-81fe-484a-ea3e-30b9d40fb700/public"
                            srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/6311559f-81fe-484a-ea3e-30b9d40fb700/public"
                            data-v-8bc7c3b9=""
                          />
                          <source
                            type="image/png?v=1"
                            data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/6311559f-81fe-484a-ea3e-30b9d40fb700/public"
                            srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/6311559f-81fe-484a-ea3e-30b9d40fb700/public"
                            data-v-8bc7c3b9=""
                          />
                          <img
                            className="img-fluid -icon-image ls-is-cached lazyloaded"
                            data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/6311559f-81fe-484a-ea3e-30b9d40fb700/public"
                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/6311559f-81fe-484a-ea3e-30b9d40fb700/public"
                            data-v-8bc7c3b9=""
                          />
                        </picture>
                        <div className="-typo-wrapper" data-v-8bc7c3b9="">
                          <div className="-typo -is-logged" data-v-8bc7c3b9="">
                            <span data-v-8bc7c3b9="">เเลกของรางวัล</span>
                          </div>
                        </div>
                      </a>
                    </div> */}
                                        {/**/}
                                        <div className="col-6 -wrapper-box" data-v-8bc7c3b9="">
                                            <a
                                                href="/logout"
                                                role="button"
                                                className="btn -btn-item -event-button -menu-center -horizontal"
                                                data-v-8bc7c3b9=""
                                            >
                                                <picture data-v-8bc7c3b9="">
                                                    <source
                                                        type="image/webp"
                                                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/630a8cf7-f7a8-4ff3-0e58-0b9929ce5500/public"
                                                        srcSet="
                  https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/630a8cf7-f7a8-4ff3-0e58-0b9929ce5500/public
                "
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <source
                                                        type="image/png?v=1"
                                                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/630a8cf7-f7a8-4ff3-0e58-0b9929ce5500/public"
                                                        srcSet="
                  https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/630a8cf7-f7a8-4ff3-0e58-0b9929ce5500/public
                "
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <img
                                                        className="img-fluid -icon-image ls-is-cached lazyloaded"
                                                        data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/630a8cf7-f7a8-4ff3-0e58-0b9929ce5500/public"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/630a8cf7-f7a8-4ff3-0e58-0b9929ce5500/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                </picture>
                                                <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                                    <div className="-typo -is-logged" data-v-8bc7c3b9="">
                                                        ออกจากระบบ
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/**/}
                </div>
                <div className="base-modal-overlay x-modal modal -v2 x-theme-switcher-v2 show animated animatedFadeInUp fadeInUp"
                    data-v-0c0c7fd4=""
                    style={{ display: this.state.modalx ? "" : "none" }}
                >
                    <div
                        className="base-modal pt-0 pb-0 w-100"
                        data-v-8bc7c3b9=""
                        style={{ margin: 10, textAlign: "-webkit-center" }}
                    >
                        <div
                            className="modal-dialog -modal-size -v2 modal-dialog-centered modal-dialog-scrollable modal-dialog-centered w-100 m-0"
                            data-v-8bc7c3b9=""
                            style={{ height: "auto" }}
                        >


                            <div
                                className="modal-content -modal-content text-white-v1"
                                data-v-8bc7c3b9=""
                            >
                                <a
                                    onClick={(e) => {
                                        this.setState({
                                            modalx: false
                                        });
                                    }}
                                    role="button"
                                    className="close-model-head mt-4 mb-4"
                                    data-v-8bc7c3b9=""
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={30}
                                        height={30}
                                        fill="currentColor"
                                        className="bi bi-x-circle-fill"
                                        viewBox="0 0 16 16"
                                        data-v-8bc7c3b9=""
                                    >
                                        <path
                                            d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"
                                            data-v-8bc7c3b9=""
                                        />
                                    </svg>
                                </a>


                                <div className="pt-3 pb-4 x-theme-switcher-v2 text-center mt-3"
                                    data-v-8bc7c3b9=""
                                >
                                    <div className="-inner-header-section" data-v-8bc7c3b9="">
                                        <img
                                            src="/build/web/igame-index-lobby-wm/img/logo.png?v=1"
                                            alt=""
                                            data-v-8bc7c3b9=""
                                            style={{ width: 160 }}
                                        />
                                    </div>
                                    {(loginstate != null) ? (!loginstate) ?
                                        <div className="row -inner-top-body-section" data-v-8bc7c3b9="">
                                            <div
                                                className="col-6 -wrapper-box"
                                                data-v-8bc7c3b9=""
                                                style={{ paddingLeft: 0 }}
                                            >
                                                <a
                                                    onClick={(e) => {
                                                        this.checkurl(e, "/register")
                                                    }}
                                                    type="button"
                                                    className="btn -btn-item x-transaction-button-v2 -deposit -top-btn -horizontal"
                                                    data-v-8bc7c3b9=""
                                                >
                                                    <img
                                                        alt="img webรูปไอคอนฝากเงิน"
                                                        className="img-fluid -icon-image"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/279056cb-32d6-4c6d-7291-44366ffa1500/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                                        <div className="-title" data-v-8bc7c3b9="">
                                                            สมัครสมาชิก
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                            <div
                                                className="col-6 -wrapper-box"
                                                data-v-8bc7c3b9=""
                                                style={{ paddingRight: 0 }}
                                            >
                                                <a
                                                    onClick={(e) => {
                                                        this.checkurl(e, "/signin")
                                                    }}
                                                    type="button"
                                                    className="btn -btn-item x-transaction-button-v2 -withdraw -top-btn -horizontal"

                                                    data-v-8bc7c3b9=""
                                                >
                                                    <img
                                                        alt=" รูปไอคอนถอนเงิน"
                                                        className="img-fluid -icon-image"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/363edcc3-13dc-460b-671d-6a37e3191e00/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                                        <div className="-title" data-v-8bc7c3b9="">
                                                            เข้าสู่ระบบ
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        </div> :
                                        <div className="row -inner-top-body-section" data-v-8bc7c3b9="">
                                            <div
                                                className="col-6 -wrapper-box"
                                                data-v-8bc7c3b9=""
                                                style={{ paddingLeft: 0 }}
                                            >
                                                <a
                                                    onClick={(e) => {
                                                        this.checkurl(e, "/deposit")
                                                    }}
                                                    role="button"
                                                    className="btn -btn-item x-transaction-button-v2 -deposit -top-btn -horizontal"
                                                    data-v-8bc7c3b9=""
                                                >
                                                    <img
                                                        className="img-fluid -icon-image"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/d2a5801c-d49e-4e57-ee32-bcb42682e400/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                                        <div className="-title" data-v-8bc7c3b9="">
                                                            ฝากเงิน
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                            <div
                                                className="col-6 -wrapper-box"
                                                data-v-8bc7c3b9=""
                                                style={{ paddingRight: 0 }}
                                            >
                                                <a
                                                    onClick={(e) => {
                                                        this.checkurl(e, "/withdraw")
                                                    }}
                                                    type="button"
                                                    className="btn -btn-item x-transaction-button-v2 -withdraw -top-btn -horizontal"
                                                    data-v-8bc7c3b9=""
                                                >
                                                    <img
                                                        className="img-fluid -icon-image"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/6829da4a-a4a5-4f8e-2ce0-286825809600/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                                        <div className="-title" data-v-8bc7c3b9="">
                                                            ถอนเงิน
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        </div> : ""}
                                    <div
                                        className="row -inner-center-body-section m-0"
                                        data-v-8bc7c3b9=""
                                    >
                                        <div className="col-6 -wrapper-box" data-v-8bc7c3b9="">
                                            <a
                                                onClick={(e) => {
                                                    this.checkurl(e, "/promotion")
                                                }}
                                                role="button"
                                                className="btn -btn-item -promotion-button -menu-center -horizontal"
                                                data-v-8bc7c3b9=""
                                            >
                                                <img
                                                    alt=" รูปไอคอนโปรโมชั่น"
                                                    className="img-fluid -icon-image ls-is-cached lazyloaded"
                                                    data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e8bbd6d-2594-4c50-3863-029c7e9a3500/public"
                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e8bbd6d-2594-4c50-3863-029c7e9a3500/public"
                                                    data-v-8bc7c3b9=""
                                                />
                                                <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                                    <div className="-typo -is-logged" style={{ color: "white" }} data-v-8bc7c3b9="">
                                                        โปรโมชั่น
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="col-6 -wrapper-box" data-v-8bc7c3b9="">
                                            <a
                                                href={this.state.linelink}
                                                role="button"
                                                className="btn -btn-item -line-button -menu-center -horizontal"
                                                rel="noopener nofollow"
                                                data-v-8bc7c3b9=""
                                            >
                                                <picture data-v-8bc7c3b9="">
                                                    <source
                                                        type="image/webp"
                                                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a5205298-bde9-4817-4f93-32dc3822b700/public"
                                                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a5205298-bde9-4817-4f93-32dc3822b700/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <source
                                                        type="image/png?v=1"
                                                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a5205298-bde9-4817-4f93-32dc3822b700/public"
                                                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a5205298-bde9-4817-4f93-32dc3822b700/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                    <img
                                                        className="img-fluid -icon-image ls-is-cached lazyloaded"
                                                        data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a5205298-bde9-4817-4f93-32dc3822b700/public"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a5205298-bde9-4817-4f93-32dc3822b700/public"
                                                        data-v-8bc7c3b9=""
                                                    />
                                                </picture>
                                                <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                                    <div className="-typo -is-logged" style={{ color: "white" }} data-v-8bc7c3b9="">
                                                        ติดต่อ
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        {/**/}
                                        <div className="col-12 -wrapper-box" data-v-8bc7c3b9="">
                                            <div
                                                className="btn -btn-item -line-button -menu-center -horizontal"
                                                data-v-8bc7c3b9=""
                                            >
                                                <div className="mt-1 mb-1 w-100" data-v-8bc7c3b9="">
                                                    <h3 className="title-footer-wrap pt-2">
                                                        <b>Language / ภาษา </b>
                                                    </h3>
                                                    <ul className="logo-list-footer">
                                                        <li role="button">
                                                            <img
                                                                className="lang-img active-lang"
                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e1626da-cc1f-451f-838f-54e5e1848f00/public"
                                                                alt=""
                                                            />
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                    <br data-v-8bc7c3b9="" />
                                </div>


                                {/**/}
                            </div>
                        </div>
                    </div>
                    {/**/}
                </div>
                {/* <div className="wrap-footer-float bg-yellow-600" id="footer-main">
                    <div className="box-footer-float">
                        <div className="inner-box-footer-float">
                            <div className="wrap-menu-foot-float">
                                <div className="item-menu-foot-float">
                                    <a role='button' onClick={(e) => {
                                        this.checkurl(e, "/")
                                    }}>
                                        <img
                                            loading="eager"
                                            src="https://dr277ea24g9fk.cloudfront.net/_bubblebee/icon_3/icon_f_home.webp"
                                            alt=""
                                        />
                                        <p>หน้าหลัก</p>
                                    </a>
                                </div>
                                <div className="item-menu-foot-float">
                                    <a role='button' onClick={(e) => {
                                        this.checkurl(e, "/deposit")
                                    }}>
                                        <img
                                            loading="eager"
                                            src="https://dr277ea24g9fk.cloudfront.net/_bubblebee/icon_3/icon_f_deposit.webp"
                                            alt=""
                                        />
                                        <p>ฝากเงิน</p>
                                    </a>
                                </div>
                                <div className="item-menu-foot-float">
                                    <a role='button' onClick={(e) => {
                                        this.checkurl(e, "/")
                                    }}>
                                        <img
                                            style={{ marginLeft: "-5px" }}
                                            loading="eager"
                                            src="https://dr277ea24g9fk.cloudfront.net/_bubblebee/icon_3/icon_f_play.webp"
                                            alt=""
                                        />
                                        <p>เล่นเกม</p>
                                    </a>
                                </div>
                                <div className="item-menu-foot-float">
                                    <a role='button' onClick={(e) => {
                                        this.checkurl(e, "/withdraw")
                                    }}>
                                        <img
                                            loading="eager"
                                            src="https://dr277ea24g9fk.cloudfront.net/_bubblebee/icon_3/icon_f_withdraw.webp"
                                            alt=""
                                        />
                                        <p>ถอนเงิน</p>
                                    </a>
                                </div>
                                <div className="item-menu-foot-float">
                                    <a role='button' onClick={(e) => {
                                        this.checkurl(e, "/withdraw")
                                    }}>
                                        <img
                                            loading="eager"
                                            src="https://dr277ea24g9fk.cloudfront.net/_bubblebee/icon_3/icon_f_cashback.webp"
                                            alt=""
                                        />
                                        <p>รับเงินคืน</p>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="100%"
                        height="100%"
                        viewBox="0 0 430 73"
                        fill="none"
                    >
                        <mask id="path-1-inside-1_4889_12797" fill="white">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M162.4 22.4282C155.644 10.8063 144.938 0 131.495 0H-2C-4.20914 0 -6 1.79086 -6 4V74C-6 74.5523 -5.55227 75 -4.99999 75H435C435.552 75 436 74.5523 436 74V4C436 1.79086 434.209 0 432 0H294.169C280.726 0 270.019 10.8063 263.264 22.4282C253.351 39.4815 234.481 51 212.832 51C191.183 51 172.313 39.4815 162.4 22.4282Z"
                            />
                        </mask>
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M162.4 22.4282C155.644 10.8063 144.938 0 131.495 0H-2C-4.20914 0 -6 1.79086 -6 4V74C-6 74.5523 -5.55227 75 -4.99999 75H435C435.552 75 436 74.5523 436 74V4C436 1.79086 434.209 0 432 0H294.169C280.726 0 270.019 10.8063 263.264 22.4282C253.351 39.4815 234.481 51 212.832 51C191.183 51 172.313 39.4815 162.4 22.4282Z"
                            fill="url(#paint0_linear_4889_12797)"
                        />
                        <path
                            d="M263.264 22.4282L261.535 21.4232L263.264 22.4282ZM162.4 22.4282L160.671 23.4333L162.4 22.4282ZM-2 2H131.495V-2H-2V2ZM-4 4C-4 2.89543 -3.10457 2 -2 2V-2C-5.31371 -2 -8 0.686293 -8 4H-4ZM-4 74V4H-8V74H-4ZM-4.99999 73C-4.44774 73 -4 73.4477 -4 74H-8C-8 75.6569 -6.65681 77 -4.99999 77V73ZM435 73H-4.99999V77H435V73ZM434 74C434 73.4477 434.448 73 435 73V77C436.657 77 438 75.6569 438 74H434ZM434 4V74H438V4H434ZM432 2C433.105 2 434 2.89543 434 4H438C438 0.686291 435.314 -2 432 -2V2ZM294.169 2H432V-2H294.169V2ZM261.535 21.4232C251.976 37.8666 233.761 49 212.832 49V53C235.2 53 254.726 41.0963 264.993 23.4333L261.535 21.4232ZM212.832 49C191.903 49 173.687 37.8666 164.129 21.4232L160.671 23.4333C170.938 41.0963 190.463 53 212.832 53V49ZM294.169 -2C279.61 -2 268.383 9.64072 261.535 21.4232L264.993 23.4333C271.655 11.972 281.842 2 294.169 2V-2ZM131.495 2C143.821 2 154.009 11.972 160.671 23.4333L164.129 21.4232C157.28 9.64072 146.054 -2 131.495 -2V2Z"
                            fill="url(#paint1_linear_4889_12797)"
                            mask="url(#path-1-inside-1_4889_12797)"
                        />
                        <defs>
                            <linearGradient
                                id="paint0_linear_4889_12797"
                                x1={215}
                                y1={0}
                                x2={215}
                                y2={75}
                                gradientUnits="userSpaceOnUse"
                            >
                                <stop stopColor="var(--theme-color-1, #3E3E3E)" />
                                <stop offset={1} stopColor="var(--theme-color-2, #0A0A0A)" />
                            </linearGradient>
                            <linearGradient
                                id="paint1_linear_4889_12797"
                                x1={-6}
                                y1={0}
                                x2="432.508"
                                y2="91.7004"
                                gradientUnits="userSpaceOnUse"
                            >
                                <stop stopColor="white" stopOpacity="0.15" />
                                <stop offset="0.21875" stopColor="white" stopOpacity="0.75" />
                                <stop offset="0.322917" stopColor="white" stopOpacity="0.15" />
                                <stop offset="0.53125" stopColor="white" stopOpacity="0.15" />
                                <stop offset="0.802083" stopColor="white" stopOpacity="0.75" />
                                <stop offset={1} stopColor="white" stopOpacity="0.15" />
                                <stop offset={1} stopColor="white" stopOpacity="0.15" />
                            </linearGradient>
                        </defs>
                    </svg>
                </div> */}
                <div className="footerMobileFixed"
                    data-v-5133983c=""
                    style={{ background: "unset !important", zIndex: 9999 }}
                >
                    <div data-v-5133983c="">
                        <div
                            className="x-button-actions"
                            id="account-actions-mobile"
                            data-v-5133983c=""
                        >
                            <div className="-outer-wrapper" data-v-5133983c="">
                                <div style={{ display: loginstate ? "none" : "" }} className="-left-wrapper border-top-hh-left" data-v-5133983c="">
                                    <a className="-item-wrapper -login" role='button' onClick={(e) => {
                                        this.checkurl(e, "/signin")
                                    }} data-v-5133983c="">
                                        <picture data-v-5133983c="">
                                            <img
                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/279056cb-32d6-4c6d-7291-44366ffa1500/public"
                                                className="-ic-img"
                                                width={30}
                                                height={30}
                                                data-v-5133983c=""
                                            />
                                        </picture>
                                        <span className="-text" data-v-5133983c="">
                                            เข้าสู่ระบบ
                                        </span>
                                    </a>
                                    <a className="-item-wrapper -login" role='button' data-v-5133983c="" onClick={(e) => {
                                        this.checkurl(e, "/register")
                                    }}>
                                        <picture data-v-5133983c="">
                                            <img
                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/363edcc3-13dc-460b-671d-6a37e3191e00/public"
                                                className="-ic-img"
                                                width={30}
                                                height={30}
                                                data-v-5133983c=""
                                            />
                                        </picture>
                                        <span className="-text" data-v-5133983c="">
                                            สมัครสมาชิก
                                        </span>
                                    </a>
                                </div>
                                <a style={{ display: loginstate ? "none" : "" }} className="-center-wrapper-v167-2 -center-wrapper"
                                    role='button'
                                    data-v-5133983c=""
                                    onClick={(e) => {
                                        this.checkurl(e, "/")
                                    }}
                                >
                                    <div
                                        className="-selected"
                                        data-v-5133983c=""
                                        style={{ textAlign: "center", padding: 0 }}
                                    >
                                        <img
                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5412f560-2ee3-41eb-6a5c-dd132d7ccb00/public"
                                            className=""
                                            data-v-5133983c=""
                                        />
                                        {/**/}
                                    </div>
                                </a>

                                <div style={{ display: loginstate ? "" : "none" }} className="-left-wrapper border-top-hh-left" data-v-5133983c="">
                                    <a className="-item-wrapper -login" role='button' onClick={(e) => {
                                        this.checkurl(e, "/deposit")
                                    }} data-v-5133983c="">
                                        <picture data-v-5133983c="">
                                            <source
                                                type="image/webp"
                                                srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/6117f3fd-7c08-4b4a-4a80-a5337a750d00/public"
                                                data-v-5133983c=""
                                            />
                                            <source
                                                type="NaN"
                                                srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/6117f3fd-7c08-4b4a-4a80-a5337a750d00/public"
                                                data-v-5133983c=""
                                            />
                                            <img
                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/6117f3fd-7c08-4b4a-4a80-a5337a750d00/public"
                                                className="-ic-img"
                                                width={35}
                                                height={35}
                                                data-v-5133983c=""
                                            />
                                        </picture>
                                        <span className="-text" data-v-5133983c="">
                                            <span
                                                className="-text d-none d-sm-inline-block"
                                                data-v-5133983c=""
                                            >
                                                ฝากเงิน
                                            </span>
                                            <span className="-text d-sm-none" data-v-5133983c="">
                                                ฝากเงิน
                                            </span>
                                        </span>
                                    </a>
                                    <a className="-item-wrapper -login" role='button' onClick={(e) => {
                                        this.checkurl(e, "/withdraw")
                                    }} data-v-5133983c="">
                                        <picture data-v-5133983c="">
                                            <source
                                                type="image/webp"
                                                srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/42eee66a-d45e-4b22-fa0f-03e3b7046400/public"
                                                data-v-5133983c=""
                                            />
                                            <source
                                                type="image/png"
                                                srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/42eee66a-d45e-4b22-fa0f-03e3b7046400/public"
                                                data-v-5133983c=""
                                            />
                                            <img
                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/42eee66a-d45e-4b22-fa0f-03e3b7046400/public"
                                                className="-ic-img"
                                                width={35}
                                                height={35}
                                                data-v-5133983c=""
                                            />
                                        </picture>
                                        <span className="-text" data-v-5133983c="">
                                            <span
                                                className="-text d-none d-sm-inline-block"
                                                data-v-5133983c=""
                                            >
                                                ถอนเงิน
                                            </span>
                                            <span className="-text d-sm-none" data-v-5133983c="">
                                                ถอนเงิน
                                            </span>
                                        </span>
                                    </a>
                                </div>
                                <a style={{ display: loginstate ? "" : "none" }}
                                    role='button' onClick={(e) => {
                                        this.checkurl(e, "/")
                                    }}
                                    className="-center-wrapper-v167-2 -center-wrapper"
                                    data-v-5133983c=""
                                >
                                    <div
                                        className="-selected"
                                        data-v-5133983c=""
                                        style={{ textAlign: "center", padding: 0 }}
                                    >
                                        <img
                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5412f560-2ee3-41eb-6a5c-dd132d7ccb00/public"
                                            className=""
                                            data-v-5133983c=""
                                        />
                                        {/**/}
                                    </div>
                                </a>

                                <div className="-fake-center-bg-wrapper" data-v-5133983c="">
                                    <svg viewBox="-10 -1 30 12" data-v-5133983c="">
                                        <defs data-v-5133983c="">
                                            <linearGradient
                                                id="rectangleGradient"
                                                x1="0%"
                                                y1="0%"
                                                x2="0%"
                                                y2="100%"
                                                data-v-5133983c=""
                                            >
                                                <stop offset="40%" stopColor="rgb(37 37 37)" data-v-5133983c="" />
                                                <stop offset="90%" stopColor="rgb(37 37 37)" data-v-5133983c="" />
                                            </linearGradient>
                                        </defs>
                                        <path
                                            d="M-10 -1 H30 V12 H-10z M 5 5 m -5, 0 a 5,5 0 1,0 10,0 a 5,5 0 1,0 -10,0z"
                                            data-v-5133983c=""
                                        />
                                    </svg>
                                </div>
                                <div className="-right-wrapper border-top-hh-right" data-v-5133983c="">
                                    <a className="-item-wrapper -affiliate" role='button' data-v-5133983c="" onClick={(e) => {
                                        this.checkurl(e, "/event")
                                    }}>
                                        <picture data-v-5133983c="">
                                            <source
                                                type="image/webp"
                                                srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/51d1ca40-4426-4008-d28c-40d0bd866900/public"
                                                data-v-5133983c=""
                                            />
                                            <source
                                                type="image/png"
                                                srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/51d1ca40-4426-4008-d28c-40d0bd866900/public"
                                                data-v-5133983c=""
                                            />
                                            <img
                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/51d1ca40-4426-4008-d28c-40d0bd866900/public"
                                                className="-ic-img"
                                                width={35}
                                                height={35}
                                                data-v-5133983c=""
                                            />
                                        </picture>
                                        <span className="-text" data-v-5133983c="">
                                            กิจกรรม
                                        </span>
                                    </a>
                                    <a

                                        href={this.state.linelink}
                                        className="-item-wrapper -line"
                                        rel="noopener noreferrer"
                                        data-v-5133983c=""
                                    >
                                        <picture data-v-5133983c="">
                                            <source
                                                type="image/webp"
                                                srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a5205298-bde9-4817-4f93-32dc3822b700/public"
                                                data-v-5133983c=""
                                            />
                                            <source
                                                type="image/png"
                                                srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a5205298-bde9-4817-4f93-32dc3822b700/public"
                                                data-v-5133983c=""
                                            />
                                            <img
                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a5205298-bde9-4817-4f93-32dc3822b700/public"
                                                className="-ic-img"
                                                width={32}
                                                height={32}
                                                data-v-5133983c=""
                                            />
                                        </picture>
                                        <span className="-text" data-v-5133983c="">
                                            Line
                                        </span>
                                    </a>
                                </div>
                                <div
                                    className="-fully-overlay js-footer-lobby-overlay"
                                    data-v-5133983c=""
                                />
                            </div>
                        </div>
                    </div>
                    {/**/}
                </div >


            </>
        );
    }
}

export default Main;
